(function () {
	'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	var isotope = {exports: {}};

	var outlayer = {exports: {}};

	var evEmitter$1 = {exports: {}};

	/**
	 * EvEmitter v1.1.0
	 * Lil' event emitter
	 * MIT License
	 */

	var hasRequiredEvEmitter$1;

	function requireEvEmitter$1 () {
		if (hasRequiredEvEmitter$1) return evEmitter$1.exports;
		hasRequiredEvEmitter$1 = 1;
		(function (module) {
			/* jshint unused: true, undef: true, strict: true */

			( function( global, factory ) {
			  // universal module definition
			  /* jshint strict: false */ /* globals define, module, window */
			  if ( module.exports ) {
			    // CommonJS - Browserify, Webpack
			    module.exports = factory();
			  } else {
			    // Browser globals
			    global.EvEmitter = factory();
			  }

			}( typeof window != 'undefined' ? window : commonjsGlobal, function() {

			function EvEmitter() {}

			var proto = EvEmitter.prototype;

			proto.on = function( eventName, listener ) {
			  if ( !eventName || !listener ) {
			    return;
			  }
			  // set events hash
			  var events = this._events = this._events || {};
			  // set listeners array
			  var listeners = events[ eventName ] = events[ eventName ] || [];
			  // only add once
			  if ( listeners.indexOf( listener ) == -1 ) {
			    listeners.push( listener );
			  }

			  return this;
			};

			proto.once = function( eventName, listener ) {
			  if ( !eventName || !listener ) {
			    return;
			  }
			  // add event
			  this.on( eventName, listener );
			  // set once flag
			  // set onceEvents hash
			  var onceEvents = this._onceEvents = this._onceEvents || {};
			  // set onceListeners object
			  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
			  // set flag
			  onceListeners[ listener ] = true;

			  return this;
			};

			proto.off = function( eventName, listener ) {
			  var listeners = this._events && this._events[ eventName ];
			  if ( !listeners || !listeners.length ) {
			    return;
			  }
			  var index = listeners.indexOf( listener );
			  if ( index != -1 ) {
			    listeners.splice( index, 1 );
			  }

			  return this;
			};

			proto.emitEvent = function( eventName, args ) {
			  var listeners = this._events && this._events[ eventName ];
			  if ( !listeners || !listeners.length ) {
			    return;
			  }
			  // copy over to avoid interference if .off() in listener
			  listeners = listeners.slice(0);
			  args = args || [];
			  // once stuff
			  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

			  for ( var i=0; i < listeners.length; i++ ) {
			    var listener = listeners[i];
			    var isOnce = onceListeners && onceListeners[ listener ];
			    if ( isOnce ) {
			      // remove listener
			      // remove before trigger to prevent recursion
			      this.off( eventName, listener );
			      // unset once flag
			      delete onceListeners[ listener ];
			    }
			    // trigger listener
			    listener.apply( this, args );
			  }

			  return this;
			};

			proto.allOff = function() {
			  delete this._events;
			  delete this._onceEvents;
			};

			return EvEmitter;

			}));
	} (evEmitter$1));
		return evEmitter$1.exports;
	}

	var getSize = {exports: {}};

	/*!
	 * getSize v2.0.3
	 * measure size of elements
	 * MIT license
	 */

	var hasRequiredGetSize;

	function requireGetSize () {
		if (hasRequiredGetSize) return getSize.exports;
		hasRequiredGetSize = 1;
		(function (module) {
			/* jshint browser: true, strict: true, undef: true, unused: true */
			/* globals console: false */

			( function( window, factory ) {
			  /* jshint strict: false */ /* globals define, module */
			  if ( module.exports ) {
			    // CommonJS
			    module.exports = factory();
			  } else {
			    // browser global
			    window.getSize = factory();
			  }

			})( window, function factory() {

			// -------------------------- helpers -------------------------- //

			// get a number from a string, not a percentage
			function getStyleSize( value ) {
			  var num = parseFloat( value );
			  // not a percent like '100%', and a number
			  var isValid = value.indexOf('%') == -1 && !isNaN( num );
			  return isValid && num;
			}

			function noop() {}

			var logError = typeof console == 'undefined' ? noop :
			  function( message ) {
			    console.error( message );
			  };

			// -------------------------- measurements -------------------------- //

			var measurements = [
			  'paddingLeft',
			  'paddingRight',
			  'paddingTop',
			  'paddingBottom',
			  'marginLeft',
			  'marginRight',
			  'marginTop',
			  'marginBottom',
			  'borderLeftWidth',
			  'borderRightWidth',
			  'borderTopWidth',
			  'borderBottomWidth'
			];

			var measurementsLength = measurements.length;

			function getZeroSize() {
			  var size = {
			    width: 0,
			    height: 0,
			    innerWidth: 0,
			    innerHeight: 0,
			    outerWidth: 0,
			    outerHeight: 0
			  };
			  for ( var i=0; i < measurementsLength; i++ ) {
			    var measurement = measurements[i];
			    size[ measurement ] = 0;
			  }
			  return size;
			}

			// -------------------------- getStyle -------------------------- //

			/**
			 * getStyle, get style of element, check for Firefox bug
			 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
			 */
			function getStyle( elem ) {
			  var style = getComputedStyle( elem );
			  if ( !style ) {
			    logError( 'Style returned ' + style +
			      '. Are you running this code in a hidden iframe on Firefox? ' +
			      'See https://bit.ly/getsizebug1' );
			  }
			  return style;
			}

			// -------------------------- setup -------------------------- //

			var isSetup = false;

			var isBoxSizeOuter;

			/**
			 * setup
			 * check isBoxSizerOuter
			 * do on first getSize() rather than on page load for Firefox bug
			 */
			function setup() {
			  // setup once
			  if ( isSetup ) {
			    return;
			  }
			  isSetup = true;

			  // -------------------------- box sizing -------------------------- //

			  /**
			   * Chrome & Safari measure the outer-width on style.width on border-box elems
			   * IE11 & Firefox<29 measures the inner-width
			   */
			  var div = document.createElement('div');
			  div.style.width = '200px';
			  div.style.padding = '1px 2px 3px 4px';
			  div.style.borderStyle = 'solid';
			  div.style.borderWidth = '1px 2px 3px 4px';
			  div.style.boxSizing = 'border-box';

			  var body = document.body || document.documentElement;
			  body.appendChild( div );
			  var style = getStyle( div );
			  // round value for browser zoom. desandro/masonry#928
			  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
			  getSize.isBoxSizeOuter = isBoxSizeOuter;

			  body.removeChild( div );
			}

			// -------------------------- getSize -------------------------- //

			function getSize( elem ) {
			  setup();

			  // use querySeletor if elem is string
			  if ( typeof elem == 'string' ) {
			    elem = document.querySelector( elem );
			  }

			  // do not proceed on non-objects
			  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
			    return;
			  }

			  var style = getStyle( elem );

			  // if hidden, everything is 0
			  if ( style.display == 'none' ) {
			    return getZeroSize();
			  }

			  var size = {};
			  size.width = elem.offsetWidth;
			  size.height = elem.offsetHeight;

			  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

			  // get all measurements
			  for ( var i=0; i < measurementsLength; i++ ) {
			    var measurement = measurements[i];
			    var value = style[ measurement ];
			    var num = parseFloat( value );
			    // any 'auto', 'medium' value will be 0
			    size[ measurement ] = !isNaN( num ) ? num : 0;
			  }

			  var paddingWidth = size.paddingLeft + size.paddingRight;
			  var paddingHeight = size.paddingTop + size.paddingBottom;
			  var marginWidth = size.marginLeft + size.marginRight;
			  var marginHeight = size.marginTop + size.marginBottom;
			  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
			  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

			  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

			  // overwrite width and height if we can get it from style
			  var styleWidth = getStyleSize( style.width );
			  if ( styleWidth !== false ) {
			    size.width = styleWidth +
			      // add padding and border unless it's already including it
			      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
			  }

			  var styleHeight = getStyleSize( style.height );
			  if ( styleHeight !== false ) {
			    size.height = styleHeight +
			      // add padding and border unless it's already including it
			      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
			  }

			  size.innerWidth = size.width - ( paddingWidth + borderWidth );
			  size.innerHeight = size.height - ( paddingHeight + borderHeight );

			  size.outerWidth = size.width + marginWidth;
			  size.outerHeight = size.height + marginHeight;

			  return size;
			}

			return getSize;

			});
	} (getSize));
		return getSize.exports;
	}

	var utils = {exports: {}};

	var matchesSelector = {exports: {}};

	/**
	 * matchesSelector v2.0.2
	 * matchesSelector( element, '.selector' )
	 * MIT license
	 */

	var hasRequiredMatchesSelector;

	function requireMatchesSelector () {
		if (hasRequiredMatchesSelector) return matchesSelector.exports;
		hasRequiredMatchesSelector = 1;
		(function (module) {
			/*jshint browser: true, strict: true, undef: true, unused: true */

			( function( window, factory ) {
			  // universal module definition
			  if ( module.exports ) {
			    // CommonJS
			    module.exports = factory();
			  } else {
			    // browser global
			    window.matchesSelector = factory();
			  }

			}( window, function factory() {

			  var matchesMethod = ( function() {
			    var ElemProto = window.Element.prototype;
			    // check for the standard method name first
			    if ( ElemProto.matches ) {
			      return 'matches';
			    }
			    // check un-prefixed
			    if ( ElemProto.matchesSelector ) {
			      return 'matchesSelector';
			    }
			    // check vendor prefixes
			    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

			    for ( var i=0; i < prefixes.length; i++ ) {
			      var prefix = prefixes[i];
			      var method = prefix + 'MatchesSelector';
			      if ( ElemProto[ method ] ) {
			        return method;
			      }
			    }
			  })();

			  return function matchesSelector( elem, selector ) {
			    return elem[ matchesMethod ]( selector );
			  };

			}));
	} (matchesSelector));
		return matchesSelector.exports;
	}

	/**
	 * Fizzy UI utils v2.0.7
	 * MIT license
	 */

	var hasRequiredUtils;

	function requireUtils () {
		if (hasRequiredUtils) return utils.exports;
		hasRequiredUtils = 1;
		(function (module) {
			/*jshint browser: true, undef: true, unused: true, strict: true */

			( function( window, factory ) {
			  // universal module definition
			  /*jshint strict: false */ /*globals define, module, require */

			  if ( module.exports ) {
			    // CommonJS
			    module.exports = factory(
			      window,
			      requireMatchesSelector()
			    );
			  } else {
			    // browser global
			    window.fizzyUIUtils = factory(
			      window,
			      window.matchesSelector
			    );
			  }

			}( window, function factory( window, matchesSelector ) {

			var utils = {};

			// ----- extend ----- //

			// extends objects
			utils.extend = function( a, b ) {
			  for ( var prop in b ) {
			    a[ prop ] = b[ prop ];
			  }
			  return a;
			};

			// ----- modulo ----- //

			utils.modulo = function( num, div ) {
			  return ( ( num % div ) + div ) % div;
			};

			// ----- makeArray ----- //

			var arraySlice = Array.prototype.slice;

			// turn element or nodeList into an array
			utils.makeArray = function( obj ) {
			  if ( Array.isArray( obj ) ) {
			    // use object if already an array
			    return obj;
			  }
			  // return empty array if undefined or null. #6
			  if ( obj === null || obj === undefined ) {
			    return [];
			  }

			  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
			  if ( isArrayLike ) {
			    // convert nodeList to array
			    return arraySlice.call( obj );
			  }

			  // array of single index
			  return [ obj ];
			};

			// ----- removeFrom ----- //

			utils.removeFrom = function( ary, obj ) {
			  var index = ary.indexOf( obj );
			  if ( index != -1 ) {
			    ary.splice( index, 1 );
			  }
			};

			// ----- getParent ----- //

			utils.getParent = function( elem, selector ) {
			  while ( elem.parentNode && elem != document.body ) {
			    elem = elem.parentNode;
			    if ( matchesSelector( elem, selector ) ) {
			      return elem;
			    }
			  }
			};

			// ----- getQueryElement ----- //

			// use element as selector string
			utils.getQueryElement = function( elem ) {
			  if ( typeof elem == 'string' ) {
			    return document.querySelector( elem );
			  }
			  return elem;
			};

			// ----- handleEvent ----- //

			// enable .ontype to trigger from .addEventListener( elem, 'type' )
			utils.handleEvent = function( event ) {
			  var method = 'on' + event.type;
			  if ( this[ method ] ) {
			    this[ method ]( event );
			  }
			};

			// ----- filterFindElements ----- //

			utils.filterFindElements = function( elems, selector ) {
			  // make array of elems
			  elems = utils.makeArray( elems );
			  var ffElems = [];

			  elems.forEach( function( elem ) {
			    // check that elem is an actual element
			    if ( !( elem instanceof HTMLElement ) ) {
			      return;
			    }
			    // add elem if no selector
			    if ( !selector ) {
			      ffElems.push( elem );
			      return;
			    }
			    // filter & find items if we have a selector
			    // filter
			    if ( matchesSelector( elem, selector ) ) {
			      ffElems.push( elem );
			    }
			    // find children
			    var childElems = elem.querySelectorAll( selector );
			    // concat childElems to filterFound array
			    for ( var i=0; i < childElems.length; i++ ) {
			      ffElems.push( childElems[i] );
			    }
			  });

			  return ffElems;
			};

			// ----- debounceMethod ----- //

			utils.debounceMethod = function( _class, methodName, threshold ) {
			  threshold = threshold || 100;
			  // original method
			  var method = _class.prototype[ methodName ];
			  var timeoutName = methodName + 'Timeout';

			  _class.prototype[ methodName ] = function() {
			    var timeout = this[ timeoutName ];
			    clearTimeout( timeout );

			    var args = arguments;
			    var _this = this;
			    this[ timeoutName ] = setTimeout( function() {
			      method.apply( _this, args );
			      delete _this[ timeoutName ];
			    }, threshold );
			  };
			};

			// ----- docReady ----- //

			utils.docReady = function( callback ) {
			  var readyState = document.readyState;
			  if ( readyState == 'complete' || readyState == 'interactive' ) {
			    // do async to allow for other scripts to run. metafizzy/flickity#441
			    setTimeout( callback );
			  } else {
			    document.addEventListener( 'DOMContentLoaded', callback );
			  }
			};

			// ----- htmlInit ----- //

			// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
			utils.toDashed = function( str ) {
			  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
			    return $1 + '-' + $2;
			  }).toLowerCase();
			};

			var console = window.console;
			/**
			 * allow user to initialize classes via [data-namespace] or .js-namespace class
			 * htmlInit( Widget, 'widgetName' )
			 * options are parsed from data-namespace-options
			 */
			utils.htmlInit = function( WidgetClass, namespace ) {
			  utils.docReady( function() {
			    var dashedNamespace = utils.toDashed( namespace );
			    var dataAttr = 'data-' + dashedNamespace;
			    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
			    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
			    var elems = utils.makeArray( dataAttrElems )
			      .concat( utils.makeArray( jsDashElems ) );
			    var dataOptionsAttr = dataAttr + '-options';
			    var jQuery = window.jQuery;

			    elems.forEach( function( elem ) {
			      var attr = elem.getAttribute( dataAttr ) ||
			        elem.getAttribute( dataOptionsAttr );
			      var options;
			      try {
			        options = attr && JSON.parse( attr );
			      } catch ( error ) {
			        // log error, do not initialize
			        if ( console ) {
			          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
			          ': ' + error );
			        }
			        return;
			      }
			      // initialize
			      var instance = new WidgetClass( elem, options );
			      // make available via $().data('namespace')
			      if ( jQuery ) {
			        jQuery.data( elem, namespace, instance );
			      }
			    });

			  });
			};

			// -----  ----- //

			return utils;

			}));
	} (utils));
		return utils.exports;
	}

	var item$1 = {exports: {}};

	/**
	 * Outlayer Item
	 */

	var hasRequiredItem$1;

	function requireItem$1 () {
		if (hasRequiredItem$1) return item$1.exports;
		hasRequiredItem$1 = 1;
		(function (module) {
			( function( window, factory ) {
			  // universal module definition
			  /* jshint strict: false */ /* globals define, module, require */
			  if ( module.exports ) {
			    // CommonJS - Browserify, Webpack
			    module.exports = factory(
			      requireEvEmitter$1(),
			      requireGetSize()
			    );
			  } else {
			    // browser global
			    window.Outlayer = {};
			    window.Outlayer.Item = factory(
			      window.EvEmitter,
			      window.getSize
			    );
			  }

			}( window, function factory( EvEmitter, getSize ) {

			// ----- helpers ----- //

			function isEmptyObj( obj ) {
			  for ( var prop in obj ) {
			    return false;
			  }
			  prop = null;
			  return true;
			}

			// -------------------------- CSS3 support -------------------------- //


			var docElemStyle = document.documentElement.style;

			var transitionProperty = typeof docElemStyle.transition == 'string' ?
			  'transition' : 'WebkitTransition';
			var transformProperty = typeof docElemStyle.transform == 'string' ?
			  'transform' : 'WebkitTransform';

			var transitionEndEvent = {
			  WebkitTransition: 'webkitTransitionEnd',
			  transition: 'transitionend'
			}[ transitionProperty ];

			// cache all vendor properties that could have vendor prefix
			var vendorProperties = {
			  transform: transformProperty,
			  transition: transitionProperty,
			  transitionDuration: transitionProperty + 'Duration',
			  transitionProperty: transitionProperty + 'Property',
			  transitionDelay: transitionProperty + 'Delay'
			};

			// -------------------------- Item -------------------------- //

			function Item( element, layout ) {
			  if ( !element ) {
			    return;
			  }

			  this.element = element;
			  // parent layout class, i.e. Masonry, Isotope, or Packery
			  this.layout = layout;
			  this.position = {
			    x: 0,
			    y: 0
			  };

			  this._create();
			}

			// inherit EvEmitter
			var proto = Item.prototype = Object.create( EvEmitter.prototype );
			proto.constructor = Item;

			proto._create = function() {
			  // transition objects
			  this._transn = {
			    ingProperties: {},
			    clean: {},
			    onEnd: {}
			  };

			  this.css({
			    position: 'absolute'
			  });
			};

			// trigger specified handler for event type
			proto.handleEvent = function( event ) {
			  var method = 'on' + event.type;
			  if ( this[ method ] ) {
			    this[ method ]( event );
			  }
			};

			proto.getSize = function() {
			  this.size = getSize( this.element );
			};

			/**
			 * apply CSS styles to element
			 * @param {Object} style
			 */
			proto.css = function( style ) {
			  var elemStyle = this.element.style;

			  for ( var prop in style ) {
			    // use vendor property if available
			    var supportedProp = vendorProperties[ prop ] || prop;
			    elemStyle[ supportedProp ] = style[ prop ];
			  }
			};

			 // measure position, and sets it
			proto.getPosition = function() {
			  var style = getComputedStyle( this.element );
			  var isOriginLeft = this.layout._getOption('originLeft');
			  var isOriginTop = this.layout._getOption('originTop');
			  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
			  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
			  var x = parseFloat( xValue );
			  var y = parseFloat( yValue );
			  // convert percent to pixels
			  var layoutSize = this.layout.size;
			  if ( xValue.indexOf('%') != -1 ) {
			    x = ( x / 100 ) * layoutSize.width;
			  }
			  if ( yValue.indexOf('%') != -1 ) {
			    y = ( y / 100 ) * layoutSize.height;
			  }
			  // clean up 'auto' or other non-integer values
			  x = isNaN( x ) ? 0 : x;
			  y = isNaN( y ) ? 0 : y;
			  // remove padding from measurement
			  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
			  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

			  this.position.x = x;
			  this.position.y = y;
			};

			// set settled position, apply padding
			proto.layoutPosition = function() {
			  var layoutSize = this.layout.size;
			  var style = {};
			  var isOriginLeft = this.layout._getOption('originLeft');
			  var isOriginTop = this.layout._getOption('originTop');

			  // x
			  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
			  var xProperty = isOriginLeft ? 'left' : 'right';
			  var xResetProperty = isOriginLeft ? 'right' : 'left';

			  var x = this.position.x + layoutSize[ xPadding ];
			  // set in percentage or pixels
			  style[ xProperty ] = this.getXValue( x );
			  // reset other property
			  style[ xResetProperty ] = '';

			  // y
			  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
			  var yProperty = isOriginTop ? 'top' : 'bottom';
			  var yResetProperty = isOriginTop ? 'bottom' : 'top';

			  var y = this.position.y + layoutSize[ yPadding ];
			  // set in percentage or pixels
			  style[ yProperty ] = this.getYValue( y );
			  // reset other property
			  style[ yResetProperty ] = '';

			  this.css( style );
			  this.emitEvent( 'layout', [ this ] );
			};

			proto.getXValue = function( x ) {
			  var isHorizontal = this.layout._getOption('horizontal');
			  return this.layout.options.percentPosition && !isHorizontal ?
			    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
			};

			proto.getYValue = function( y ) {
			  var isHorizontal = this.layout._getOption('horizontal');
			  return this.layout.options.percentPosition && isHorizontal ?
			    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
			};

			proto._transitionTo = function( x, y ) {
			  this.getPosition();
			  // get current x & y from top/left
			  var curX = this.position.x;
			  var curY = this.position.y;

			  var didNotMove = x == this.position.x && y == this.position.y;

			  // save end position
			  this.setPosition( x, y );

			  // if did not move and not transitioning, just go to layout
			  if ( didNotMove && !this.isTransitioning ) {
			    this.layoutPosition();
			    return;
			  }

			  var transX = x - curX;
			  var transY = y - curY;
			  var transitionStyle = {};
			  transitionStyle.transform = this.getTranslate( transX, transY );

			  this.transition({
			    to: transitionStyle,
			    onTransitionEnd: {
			      transform: this.layoutPosition
			    },
			    isCleaning: true
			  });
			};

			proto.getTranslate = function( x, y ) {
			  // flip cooridinates if origin on right or bottom
			  var isOriginLeft = this.layout._getOption('originLeft');
			  var isOriginTop = this.layout._getOption('originTop');
			  x = isOriginLeft ? x : -x;
			  y = isOriginTop ? y : -y;
			  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
			};

			// non transition + transform support
			proto.goTo = function( x, y ) {
			  this.setPosition( x, y );
			  this.layoutPosition();
			};

			proto.moveTo = proto._transitionTo;

			proto.setPosition = function( x, y ) {
			  this.position.x = parseFloat( x );
			  this.position.y = parseFloat( y );
			};

			// ----- transition ----- //

			/**
			 * @param {Object} style - CSS
			 * @param {Function} onTransitionEnd
			 */

			// non transition, just trigger callback
			proto._nonTransition = function( args ) {
			  this.css( args.to );
			  if ( args.isCleaning ) {
			    this._removeStyles( args.to );
			  }
			  for ( var prop in args.onTransitionEnd ) {
			    args.onTransitionEnd[ prop ].call( this );
			  }
			};

			/**
			 * proper transition
			 * @param {Object} args - arguments
			 *   @param {Object} to - style to transition to
			 *   @param {Object} from - style to start transition from
			 *   @param {Boolean} isCleaning - removes transition styles after transition
			 *   @param {Function} onTransitionEnd - callback
			 */
			proto.transition = function( args ) {
			  // redirect to nonTransition if no transition duration
			  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
			    this._nonTransition( args );
			    return;
			  }

			  var _transition = this._transn;
			  // keep track of onTransitionEnd callback by css property
			  for ( var prop in args.onTransitionEnd ) {
			    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
			  }
			  // keep track of properties that are transitioning
			  for ( prop in args.to ) {
			    _transition.ingProperties[ prop ] = true;
			    // keep track of properties to clean up when transition is done
			    if ( args.isCleaning ) {
			      _transition.clean[ prop ] = true;
			    }
			  }

			  // set from styles
			  if ( args.from ) {
			    this.css( args.from );
			    // force redraw. http://blog.alexmaccaw.com/css-transitions
			    this.element.offsetHeight;
			  }
			  // enable transition
			  this.enableTransition( args.to );
			  // set styles that are transitioning
			  this.css( args.to );

			  this.isTransitioning = true;

			};

			// dash before all cap letters, including first for
			// WebkitTransform => -webkit-transform
			function toDashedAll( str ) {
			  return str.replace( /([A-Z])/g, function( $1 ) {
			    return '-' + $1.toLowerCase();
			  });
			}

			var transitionProps = 'opacity,' + toDashedAll( transformProperty );

			proto.enableTransition = function(/* style */) {
			  // HACK changing transitionProperty during a transition
			  // will cause transition to jump
			  if ( this.isTransitioning ) {
			    return;
			  }

			  // make `transition: foo, bar, baz` from style object
			  // HACK un-comment this when enableTransition can work
			  // while a transition is happening
			  // var transitionValues = [];
			  // for ( var prop in style ) {
			  //   // dash-ify camelCased properties like WebkitTransition
			  //   prop = vendorProperties[ prop ] || prop;
			  //   transitionValues.push( toDashedAll( prop ) );
			  // }
			  // munge number to millisecond, to match stagger
			  var duration = this.layout.options.transitionDuration;
			  duration = typeof duration == 'number' ? duration + 'ms' : duration;
			  // enable transition styles
			  this.css({
			    transitionProperty: transitionProps,
			    transitionDuration: duration,
			    transitionDelay: this.staggerDelay || 0
			  });
			  // listen for transition end event
			  this.element.addEventListener( transitionEndEvent, this, false );
			};

			// ----- events ----- //

			proto.onwebkitTransitionEnd = function( event ) {
			  this.ontransitionend( event );
			};

			proto.onotransitionend = function( event ) {
			  this.ontransitionend( event );
			};

			// properties that I munge to make my life easier
			var dashedVendorProperties = {
			  '-webkit-transform': 'transform'
			};

			proto.ontransitionend = function( event ) {
			  // disregard bubbled events from children
			  if ( event.target !== this.element ) {
			    return;
			  }
			  var _transition = this._transn;
			  // get property name of transitioned property, convert to prefix-free
			  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;

			  // remove property that has completed transitioning
			  delete _transition.ingProperties[ propertyName ];
			  // check if any properties are still transitioning
			  if ( isEmptyObj( _transition.ingProperties ) ) {
			    // all properties have completed transitioning
			    this.disableTransition();
			  }
			  // clean style
			  if ( propertyName in _transition.clean ) {
			    // clean up style
			    this.element.style[ event.propertyName ] = '';
			    delete _transition.clean[ propertyName ];
			  }
			  // trigger onTransitionEnd callback
			  if ( propertyName in _transition.onEnd ) {
			    var onTransitionEnd = _transition.onEnd[ propertyName ];
			    onTransitionEnd.call( this );
			    delete _transition.onEnd[ propertyName ];
			  }

			  this.emitEvent( 'transitionEnd', [ this ] );
			};

			proto.disableTransition = function() {
			  this.removeTransitionStyles();
			  this.element.removeEventListener( transitionEndEvent, this, false );
			  this.isTransitioning = false;
			};

			/**
			 * removes style property from element
			 * @param {Object} style
			**/
			proto._removeStyles = function( style ) {
			  // clean up transition styles
			  var cleanStyle = {};
			  for ( var prop in style ) {
			    cleanStyle[ prop ] = '';
			  }
			  this.css( cleanStyle );
			};

			var cleanTransitionStyle = {
			  transitionProperty: '',
			  transitionDuration: '',
			  transitionDelay: ''
			};

			proto.removeTransitionStyles = function() {
			  // remove transition
			  this.css( cleanTransitionStyle );
			};

			// ----- stagger ----- //

			proto.stagger = function( delay ) {
			  delay = isNaN( delay ) ? 0 : delay;
			  this.staggerDelay = delay + 'ms';
			};

			// ----- show/hide/remove ----- //

			// remove element from DOM
			proto.removeElem = function() {
			  this.element.parentNode.removeChild( this.element );
			  // remove display: none
			  this.css({ display: '' });
			  this.emitEvent( 'remove', [ this ] );
			};

			proto.remove = function() {
			  // just remove element if no transition support or no transition
			  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
			    this.removeElem();
			    return;
			  }

			  // start transition
			  this.once( 'transitionEnd', function() {
			    this.removeElem();
			  });
			  this.hide();
			};

			proto.reveal = function() {
			  delete this.isHidden;
			  // remove display: none
			  this.css({ display: '' });

			  var options = this.layout.options;

			  var onTransitionEnd = {};
			  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
			  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;

			  this.transition({
			    from: options.hiddenStyle,
			    to: options.visibleStyle,
			    isCleaning: true,
			    onTransitionEnd: onTransitionEnd
			  });
			};

			proto.onRevealTransitionEnd = function() {
			  // check if still visible
			  // during transition, item may have been hidden
			  if ( !this.isHidden ) {
			    this.emitEvent('reveal');
			  }
			};

			/**
			 * get style property use for hide/reveal transition end
			 * @param {String} styleProperty - hiddenStyle/visibleStyle
			 * @returns {String}
			 */
			proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
			  var optionStyle = this.layout.options[ styleProperty ];
			  // use opacity
			  if ( optionStyle.opacity ) {
			    return 'opacity';
			  }
			  // get first property
			  for ( var prop in optionStyle ) {
			    return prop;
			  }
			};

			proto.hide = function() {
			  // set flag
			  this.isHidden = true;
			  // remove display: none
			  this.css({ display: '' });

			  var options = this.layout.options;

			  var onTransitionEnd = {};
			  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
			  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;

			  this.transition({
			    from: options.visibleStyle,
			    to: options.hiddenStyle,
			    // keep hidden stuff hidden
			    isCleaning: true,
			    onTransitionEnd: onTransitionEnd
			  });
			};

			proto.onHideTransitionEnd = function() {
			  // check if still hidden
			  // during transition, item may have been un-hidden
			  if ( this.isHidden ) {
			    this.css({ display: 'none' });
			    this.emitEvent('hide');
			  }
			};

			proto.destroy = function() {
			  this.css({
			    position: '',
			    left: '',
			    right: '',
			    top: '',
			    bottom: '',
			    transition: '',
			    transform: ''
			  });
			};

			return Item;

			}));
	} (item$1));
		return item$1.exports;
	}

	/*!
	 * Outlayer v2.1.1
	 * the brains and guts of a layout library
	 * MIT license
	 */

	var hasRequiredOutlayer;

	function requireOutlayer () {
		if (hasRequiredOutlayer) return outlayer.exports;
		hasRequiredOutlayer = 1;
		(function (module) {
			( function( window, factory ) {
			  // universal module definition
			  /* jshint strict: false */ /* globals define, module, require */
			  if ( module.exports ) {
			    // CommonJS - Browserify, Webpack
			    module.exports = factory(
			      window,
			      requireEvEmitter$1(),
			      requireGetSize(),
			      requireUtils(),
			      requireItem$1()
			    );
			  } else {
			    // browser global
			    window.Outlayer = factory(
			      window,
			      window.EvEmitter,
			      window.getSize,
			      window.fizzyUIUtils,
			      window.Outlayer.Item
			    );
			  }

			}( window, function factory( window, EvEmitter, getSize, utils, Item ) {

			// ----- vars ----- //

			var console = window.console;
			var jQuery = window.jQuery;
			var noop = function() {};

			// -------------------------- Outlayer -------------------------- //

			// globally unique identifiers
			var GUID = 0;
			// internal store of all Outlayer intances
			var instances = {};


			/**
			 * @param {Element, String} element
			 * @param {Object} options
			 * @constructor
			 */
			function Outlayer( element, options ) {
			  var queryElement = utils.getQueryElement( element );
			  if ( !queryElement ) {
			    if ( console ) {
			      console.error( 'Bad element for ' + this.constructor.namespace +
			        ': ' + ( queryElement || element ) );
			    }
			    return;
			  }
			  this.element = queryElement;
			  // add jQuery
			  if ( jQuery ) {
			    this.$element = jQuery( this.element );
			  }

			  // options
			  this.options = utils.extend( {}, this.constructor.defaults );
			  this.option( options );

			  // add id for Outlayer.getFromElement
			  var id = ++GUID;
			  this.element.outlayerGUID = id; // expando
			  instances[ id ] = this; // associate via id

			  // kick it off
			  this._create();

			  var isInitLayout = this._getOption('initLayout');
			  if ( isInitLayout ) {
			    this.layout();
			  }
			}

			// settings are for internal use only
			Outlayer.namespace = 'outlayer';
			Outlayer.Item = Item;

			// default options
			Outlayer.defaults = {
			  containerStyle: {
			    position: 'relative'
			  },
			  initLayout: true,
			  originLeft: true,
			  originTop: true,
			  resize: true,
			  resizeContainer: true,
			  // item options
			  transitionDuration: '0.4s',
			  hiddenStyle: {
			    opacity: 0,
			    transform: 'scale(0.001)'
			  },
			  visibleStyle: {
			    opacity: 1,
			    transform: 'scale(1)'
			  }
			};

			var proto = Outlayer.prototype;
			// inherit EvEmitter
			utils.extend( proto, EvEmitter.prototype );

			/**
			 * set options
			 * @param {Object} opts
			 */
			proto.option = function( opts ) {
			  utils.extend( this.options, opts );
			};

			/**
			 * get backwards compatible option value, check old name
			 */
			proto._getOption = function( option ) {
			  var oldOption = this.constructor.compatOptions[ option ];
			  return oldOption && this.options[ oldOption ] !== undefined ?
			    this.options[ oldOption ] : this.options[ option ];
			};

			Outlayer.compatOptions = {
			  // currentName: oldName
			  initLayout: 'isInitLayout',
			  horizontal: 'isHorizontal',
			  layoutInstant: 'isLayoutInstant',
			  originLeft: 'isOriginLeft',
			  originTop: 'isOriginTop',
			  resize: 'isResizeBound',
			  resizeContainer: 'isResizingContainer'
			};

			proto._create = function() {
			  // get items from children
			  this.reloadItems();
			  // elements that affect layout, but are not laid out
			  this.stamps = [];
			  this.stamp( this.options.stamp );
			  // set container style
			  utils.extend( this.element.style, this.options.containerStyle );

			  // bind resize method
			  var canBindResize = this._getOption('resize');
			  if ( canBindResize ) {
			    this.bindResize();
			  }
			};

			// goes through all children again and gets bricks in proper order
			proto.reloadItems = function() {
			  // collection of item elements
			  this.items = this._itemize( this.element.children );
			};


			/**
			 * turn elements into Outlayer.Items to be used in layout
			 * @param {Array or NodeList or HTMLElement} elems
			 * @returns {Array} items - collection of new Outlayer Items
			 */
			proto._itemize = function( elems ) {

			  var itemElems = this._filterFindItemElements( elems );
			  var Item = this.constructor.Item;

			  // create new Outlayer Items for collection
			  var items = [];
			  for ( var i=0; i < itemElems.length; i++ ) {
			    var elem = itemElems[i];
			    var item = new Item( elem, this );
			    items.push( item );
			  }

			  return items;
			};

			/**
			 * get item elements to be used in layout
			 * @param {Array or NodeList or HTMLElement} elems
			 * @returns {Array} items - item elements
			 */
			proto._filterFindItemElements = function( elems ) {
			  return utils.filterFindElements( elems, this.options.itemSelector );
			};

			/**
			 * getter method for getting item elements
			 * @returns {Array} elems - collection of item elements
			 */
			proto.getItemElements = function() {
			  return this.items.map( function( item ) {
			    return item.element;
			  });
			};

			// ----- init & layout ----- //

			/**
			 * lays out all items
			 */
			proto.layout = function() {
			  this._resetLayout();
			  this._manageStamps();

			  // don't animate first layout
			  var layoutInstant = this._getOption('layoutInstant');
			  var isInstant = layoutInstant !== undefined ?
			    layoutInstant : !this._isLayoutInited;
			  this.layoutItems( this.items, isInstant );

			  // flag for initalized
			  this._isLayoutInited = true;
			};

			// _init is alias for layout
			proto._init = proto.layout;

			/**
			 * logic before any new layout
			 */
			proto._resetLayout = function() {
			  this.getSize();
			};


			proto.getSize = function() {
			  this.size = getSize( this.element );
			};

			/**
			 * get measurement from option, for columnWidth, rowHeight, gutter
			 * if option is String -> get element from selector string, & get size of element
			 * if option is Element -> get size of element
			 * else use option as a number
			 *
			 * @param {String} measurement
			 * @param {String} size - width or height
			 * @private
			 */
			proto._getMeasurement = function( measurement, size ) {
			  var option = this.options[ measurement ];
			  var elem;
			  if ( !option ) {
			    // default to 0
			    this[ measurement ] = 0;
			  } else {
			    // use option as an element
			    if ( typeof option == 'string' ) {
			      elem = this.element.querySelector( option );
			    } else if ( option instanceof HTMLElement ) {
			      elem = option;
			    }
			    // use size of element, if element
			    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
			  }
			};

			/**
			 * layout a collection of item elements
			 * @api public
			 */
			proto.layoutItems = function( items, isInstant ) {
			  items = this._getItemsForLayout( items );

			  this._layoutItems( items, isInstant );

			  this._postLayout();
			};

			/**
			 * get the items to be laid out
			 * you may want to skip over some items
			 * @param {Array} items
			 * @returns {Array} items
			 */
			proto._getItemsForLayout = function( items ) {
			  return items.filter( function( item ) {
			    return !item.isIgnored;
			  });
			};

			/**
			 * layout items
			 * @param {Array} items
			 * @param {Boolean} isInstant
			 */
			proto._layoutItems = function( items, isInstant ) {
			  this._emitCompleteOnItems( 'layout', items );

			  if ( !items || !items.length ) {
			    // no items, emit event with empty array
			    return;
			  }

			  var queue = [];

			  items.forEach( function( item ) {
			    // get x/y object from method
			    var position = this._getItemLayoutPosition( item );
			    // enqueue
			    position.item = item;
			    position.isInstant = isInstant || item.isLayoutInstant;
			    queue.push( position );
			  }, this );

			  this._processLayoutQueue( queue );
			};

			/**
			 * get item layout position
			 * @param {Outlayer.Item} item
			 * @returns {Object} x and y position
			 */
			proto._getItemLayoutPosition = function( /* item */ ) {
			  return {
			    x: 0,
			    y: 0
			  };
			};

			/**
			 * iterate over array and position each item
			 * Reason being - separating this logic prevents 'layout invalidation'
			 * thx @paul_irish
			 * @param {Array} queue
			 */
			proto._processLayoutQueue = function( queue ) {
			  this.updateStagger();
			  queue.forEach( function( obj, i ) {
			    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
			  }, this );
			};

			// set stagger from option in milliseconds number
			proto.updateStagger = function() {
			  var stagger = this.options.stagger;
			  if ( stagger === null || stagger === undefined ) {
			    this.stagger = 0;
			    return;
			  }
			  this.stagger = getMilliseconds( stagger );
			  return this.stagger;
			};

			/**
			 * Sets position of item in DOM
			 * @param {Outlayer.Item} item
			 * @param {Number} x - horizontal position
			 * @param {Number} y - vertical position
			 * @param {Boolean} isInstant - disables transitions
			 */
			proto._positionItem = function( item, x, y, isInstant, i ) {
			  if ( isInstant ) {
			    // if not transition, just set CSS
			    item.goTo( x, y );
			  } else {
			    item.stagger( i * this.stagger );
			    item.moveTo( x, y );
			  }
			};

			/**
			 * Any logic you want to do after each layout,
			 * i.e. size the container
			 */
			proto._postLayout = function() {
			  this.resizeContainer();
			};

			proto.resizeContainer = function() {
			  var isResizingContainer = this._getOption('resizeContainer');
			  if ( !isResizingContainer ) {
			    return;
			  }
			  var size = this._getContainerSize();
			  if ( size ) {
			    this._setContainerMeasure( size.width, true );
			    this._setContainerMeasure( size.height, false );
			  }
			};

			/**
			 * Sets width or height of container if returned
			 * @returns {Object} size
			 *   @param {Number} width
			 *   @param {Number} height
			 */
			proto._getContainerSize = noop;

			/**
			 * @param {Number} measure - size of width or height
			 * @param {Boolean} isWidth
			 */
			proto._setContainerMeasure = function( measure, isWidth ) {
			  if ( measure === undefined ) {
			    return;
			  }

			  var elemSize = this.size;
			  // add padding and border width if border box
			  if ( elemSize.isBorderBox ) {
			    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
			      elemSize.borderLeftWidth + elemSize.borderRightWidth :
			      elemSize.paddingBottom + elemSize.paddingTop +
			      elemSize.borderTopWidth + elemSize.borderBottomWidth;
			  }

			  measure = Math.max( measure, 0 );
			  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
			};

			/**
			 * emit eventComplete on a collection of items events
			 * @param {String} eventName
			 * @param {Array} items - Outlayer.Items
			 */
			proto._emitCompleteOnItems = function( eventName, items ) {
			  var _this = this;
			  function onComplete() {
			    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
			  }

			  var count = items.length;
			  if ( !items || !count ) {
			    onComplete();
			    return;
			  }

			  var doneCount = 0;
			  function tick() {
			    doneCount++;
			    if ( doneCount == count ) {
			      onComplete();
			    }
			  }

			  // bind callback
			  items.forEach( function( item ) {
			    item.once( eventName, tick );
			  });
			};

			/**
			 * emits events via EvEmitter and jQuery events
			 * @param {String} type - name of event
			 * @param {Event} event - original event
			 * @param {Array} args - extra arguments
			 */
			proto.dispatchEvent = function( type, event, args ) {
			  // add original event to arguments
			  var emitArgs = event ? [ event ].concat( args ) : args;
			  this.emitEvent( type, emitArgs );

			  if ( jQuery ) {
			    // set this.$element
			    this.$element = this.$element || jQuery( this.element );
			    if ( event ) {
			      // create jQuery event
			      var $event = jQuery.Event( event );
			      $event.type = type;
			      this.$element.trigger( $event, args );
			    } else {
			      // just trigger with type if no event available
			      this.$element.trigger( type, args );
			    }
			  }
			};

			// -------------------------- ignore & stamps -------------------------- //


			/**
			 * keep item in collection, but do not lay it out
			 * ignored items do not get skipped in layout
			 * @param {Element} elem
			 */
			proto.ignore = function( elem ) {
			  var item = this.getItem( elem );
			  if ( item ) {
			    item.isIgnored = true;
			  }
			};

			/**
			 * return item to layout collection
			 * @param {Element} elem
			 */
			proto.unignore = function( elem ) {
			  var item = this.getItem( elem );
			  if ( item ) {
			    delete item.isIgnored;
			  }
			};

			/**
			 * adds elements to stamps
			 * @param {NodeList, Array, Element, or String} elems
			 */
			proto.stamp = function( elems ) {
			  elems = this._find( elems );
			  if ( !elems ) {
			    return;
			  }

			  this.stamps = this.stamps.concat( elems );
			  // ignore
			  elems.forEach( this.ignore, this );
			};

			/**
			 * removes elements to stamps
			 * @param {NodeList, Array, or Element} elems
			 */
			proto.unstamp = function( elems ) {
			  elems = this._find( elems );
			  if ( !elems ){
			    return;
			  }

			  elems.forEach( function( elem ) {
			    // filter out removed stamp elements
			    utils.removeFrom( this.stamps, elem );
			    this.unignore( elem );
			  }, this );
			};

			/**
			 * finds child elements
			 * @param {NodeList, Array, Element, or String} elems
			 * @returns {Array} elems
			 */
			proto._find = function( elems ) {
			  if ( !elems ) {
			    return;
			  }
			  // if string, use argument as selector string
			  if ( typeof elems == 'string' ) {
			    elems = this.element.querySelectorAll( elems );
			  }
			  elems = utils.makeArray( elems );
			  return elems;
			};

			proto._manageStamps = function() {
			  if ( !this.stamps || !this.stamps.length ) {
			    return;
			  }

			  this._getBoundingRect();

			  this.stamps.forEach( this._manageStamp, this );
			};

			// update boundingLeft / Top
			proto._getBoundingRect = function() {
			  // get bounding rect for container element
			  var boundingRect = this.element.getBoundingClientRect();
			  var size = this.size;
			  this._boundingRect = {
			    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
			    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
			    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
			    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
			  };
			};

			/**
			 * @param {Element} stamp
			**/
			proto._manageStamp = noop;

			/**
			 * get x/y position of element relative to container element
			 * @param {Element} elem
			 * @returns {Object} offset - has left, top, right, bottom
			 */
			proto._getElementOffset = function( elem ) {
			  var boundingRect = elem.getBoundingClientRect();
			  var thisRect = this._boundingRect;
			  var size = getSize( elem );
			  var offset = {
			    left: boundingRect.left - thisRect.left - size.marginLeft,
			    top: boundingRect.top - thisRect.top - size.marginTop,
			    right: thisRect.right - boundingRect.right - size.marginRight,
			    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
			  };
			  return offset;
			};

			// -------------------------- resize -------------------------- //

			// enable event handlers for listeners
			// i.e. resize -> onresize
			proto.handleEvent = utils.handleEvent;

			/**
			 * Bind layout to window resizing
			 */
			proto.bindResize = function() {
			  window.addEventListener( 'resize', this );
			  this.isResizeBound = true;
			};

			/**
			 * Unbind layout to window resizing
			 */
			proto.unbindResize = function() {
			  window.removeEventListener( 'resize', this );
			  this.isResizeBound = false;
			};

			proto.onresize = function() {
			  this.resize();
			};

			utils.debounceMethod( Outlayer, 'onresize', 100 );

			proto.resize = function() {
			  // don't trigger if size did not change
			  // or if resize was unbound. See #9
			  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
			    return;
			  }

			  this.layout();
			};

			/**
			 * check if layout is needed post layout
			 * @returns Boolean
			 */
			proto.needsResizeLayout = function() {
			  var size = getSize( this.element );
			  // check that this.size and size are there
			  // IE8 triggers resize on body size change, so they might not be
			  var hasSizes = this.size && size;
			  return hasSizes && size.innerWidth !== this.size.innerWidth;
			};

			// -------------------------- methods -------------------------- //

			/**
			 * add items to Outlayer instance
			 * @param {Array or NodeList or Element} elems
			 * @returns {Array} items - Outlayer.Items
			**/
			proto.addItems = function( elems ) {
			  var items = this._itemize( elems );
			  // add items to collection
			  if ( items.length ) {
			    this.items = this.items.concat( items );
			  }
			  return items;
			};

			/**
			 * Layout newly-appended item elements
			 * @param {Array or NodeList or Element} elems
			 */
			proto.appended = function( elems ) {
			  var items = this.addItems( elems );
			  if ( !items.length ) {
			    return;
			  }
			  // layout and reveal just the new items
			  this.layoutItems( items, true );
			  this.reveal( items );
			};

			/**
			 * Layout prepended elements
			 * @param {Array or NodeList or Element} elems
			 */
			proto.prepended = function( elems ) {
			  var items = this._itemize( elems );
			  if ( !items.length ) {
			    return;
			  }
			  // add items to beginning of collection
			  var previousItems = this.items.slice(0);
			  this.items = items.concat( previousItems );
			  // start new layout
			  this._resetLayout();
			  this._manageStamps();
			  // layout new stuff without transition
			  this.layoutItems( items, true );
			  this.reveal( items );
			  // layout previous items
			  this.layoutItems( previousItems );
			};

			/**
			 * reveal a collection of items
			 * @param {Array of Outlayer.Items} items
			 */
			proto.reveal = function( items ) {
			  this._emitCompleteOnItems( 'reveal', items );
			  if ( !items || !items.length ) {
			    return;
			  }
			  var stagger = this.updateStagger();
			  items.forEach( function( item, i ) {
			    item.stagger( i * stagger );
			    item.reveal();
			  });
			};

			/**
			 * hide a collection of items
			 * @param {Array of Outlayer.Items} items
			 */
			proto.hide = function( items ) {
			  this._emitCompleteOnItems( 'hide', items );
			  if ( !items || !items.length ) {
			    return;
			  }
			  var stagger = this.updateStagger();
			  items.forEach( function( item, i ) {
			    item.stagger( i * stagger );
			    item.hide();
			  });
			};

			/**
			 * reveal item elements
			 * @param {Array}, {Element}, {NodeList} items
			 */
			proto.revealItemElements = function( elems ) {
			  var items = this.getItems( elems );
			  this.reveal( items );
			};

			/**
			 * hide item elements
			 * @param {Array}, {Element}, {NodeList} items
			 */
			proto.hideItemElements = function( elems ) {
			  var items = this.getItems( elems );
			  this.hide( items );
			};

			/**
			 * get Outlayer.Item, given an Element
			 * @param {Element} elem
			 * @param {Function} callback
			 * @returns {Outlayer.Item} item
			 */
			proto.getItem = function( elem ) {
			  // loop through items to get the one that matches
			  for ( var i=0; i < this.items.length; i++ ) {
			    var item = this.items[i];
			    if ( item.element == elem ) {
			      // return item
			      return item;
			    }
			  }
			};

			/**
			 * get collection of Outlayer.Items, given Elements
			 * @param {Array} elems
			 * @returns {Array} items - Outlayer.Items
			 */
			proto.getItems = function( elems ) {
			  elems = utils.makeArray( elems );
			  var items = [];
			  elems.forEach( function( elem ) {
			    var item = this.getItem( elem );
			    if ( item ) {
			      items.push( item );
			    }
			  }, this );

			  return items;
			};

			/**
			 * remove element(s) from instance and DOM
			 * @param {Array or NodeList or Element} elems
			 */
			proto.remove = function( elems ) {
			  var removeItems = this.getItems( elems );

			  this._emitCompleteOnItems( 'remove', removeItems );

			  // bail if no items to remove
			  if ( !removeItems || !removeItems.length ) {
			    return;
			  }

			  removeItems.forEach( function( item ) {
			    item.remove();
			    // remove item from collection
			    utils.removeFrom( this.items, item );
			  }, this );
			};

			// ----- destroy ----- //

			// remove and disable Outlayer instance
			proto.destroy = function() {
			  // clean up dynamic styles
			  var style = this.element.style;
			  style.height = '';
			  style.position = '';
			  style.width = '';
			  // destroy items
			  this.items.forEach( function( item ) {
			    item.destroy();
			  });

			  this.unbindResize();

			  var id = this.element.outlayerGUID;
			  delete instances[ id ]; // remove reference to instance by id
			  delete this.element.outlayerGUID;
			  // remove data for jQuery
			  if ( jQuery ) {
			    jQuery.removeData( this.element, this.constructor.namespace );
			  }

			};

			// -------------------------- data -------------------------- //

			/**
			 * get Outlayer instance from element
			 * @param {Element} elem
			 * @returns {Outlayer}
			 */
			Outlayer.data = function( elem ) {
			  elem = utils.getQueryElement( elem );
			  var id = elem && elem.outlayerGUID;
			  return id && instances[ id ];
			};


			// -------------------------- create Outlayer class -------------------------- //

			/**
			 * create a layout class
			 * @param {String} namespace
			 */
			Outlayer.create = function( namespace, options ) {
			  // sub-class Outlayer
			  var Layout = subclass( Outlayer );
			  // apply new options and compatOptions
			  Layout.defaults = utils.extend( {}, Outlayer.defaults );
			  utils.extend( Layout.defaults, options );
			  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );

			  Layout.namespace = namespace;

			  Layout.data = Outlayer.data;

			  // sub-class Item
			  Layout.Item = subclass( Item );

			  // -------------------------- declarative -------------------------- //

			  utils.htmlInit( Layout, namespace );

			  // -------------------------- jQuery bridge -------------------------- //

			  // make into jQuery plugin
			  if ( jQuery && jQuery.bridget ) {
			    jQuery.bridget( namespace, Layout );
			  }

			  return Layout;
			};

			function subclass( Parent ) {
			  function SubClass() {
			    Parent.apply( this, arguments );
			  }

			  SubClass.prototype = Object.create( Parent.prototype );
			  SubClass.prototype.constructor = SubClass;

			  return SubClass;
			}

			// ----- helpers ----- //

			// how many milliseconds are in each unit
			var msUnits = {
			  ms: 1,
			  s: 1000
			};

			// munge time-like parameter into millisecond number
			// '0.4s' -> 40
			function getMilliseconds( time ) {
			  if ( typeof time == 'number' ) {
			    return time;
			  }
			  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
			  var num = matches && matches[1];
			  var unit = matches && matches[2];
			  if ( !num.length ) {
			    return 0;
			  }
			  num = parseFloat( num );
			  var mult = msUnits[ unit ] || 1;
			  return num * mult;
			}

			// ----- fin ----- //

			// back in global
			Outlayer.Item = Item;

			return Outlayer;

			}));
	} (outlayer));
		return outlayer.exports;
	}

	var item = {exports: {}};

	/**
	 * Isotope Item
	**/

	var hasRequiredItem;

	function requireItem () {
		if (hasRequiredItem) return item.exports;
		hasRequiredItem = 1;
		(function (module) {
			( function( window, factory ) {
			  // universal module definition
			  /* jshint strict: false */ /*globals define, module, require */
			  if ( module.exports ) {
			    // CommonJS
			    module.exports = factory(
			      requireOutlayer()
			    );
			  } else {
			    // browser global
			    window.Isotope = window.Isotope || {};
			    window.Isotope.Item = factory(
			      window.Outlayer
			    );
			  }

			}( window, function factory( Outlayer ) {

			// -------------------------- Item -------------------------- //

			// sub-class Outlayer Item
			function Item() {
			  Outlayer.Item.apply( this, arguments );
			}

			var proto = Item.prototype = Object.create( Outlayer.Item.prototype );

			var _create = proto._create;
			proto._create = function() {
			  // assign id, used for original-order sorting
			  this.id = this.layout.itemGUID++;
			  _create.call( this );
			  this.sortData = {};
			};

			proto.updateSortData = function() {
			  if ( this.isIgnored ) {
			    return;
			  }
			  // default sorters
			  this.sortData.id = this.id;
			  // for backward compatibility
			  this.sortData['original-order'] = this.id;
			  this.sortData.random = Math.random();
			  // go thru getSortData obj and apply the sorters
			  var getSortData = this.layout.options.getSortData;
			  var sorters = this.layout._sorters;
			  for ( var key in getSortData ) {
			    var sorter = sorters[ key ];
			    this.sortData[ key ] = sorter( this.element, this );
			  }
			};

			var _destroy = proto.destroy;
			proto.destroy = function() {
			  // call super
			  _destroy.apply( this, arguments );
			  // reset display, #741
			  this.css({
			    display: ''
			  });
			};

			return Item;

			}));
	} (item));
		return item.exports;
	}

	var layoutMode = {exports: {}};

	/**
	 * Isotope LayoutMode
	 */

	var hasRequiredLayoutMode;

	function requireLayoutMode () {
		if (hasRequiredLayoutMode) return layoutMode.exports;
		hasRequiredLayoutMode = 1;
		(function (module) {
			( function( window, factory ) {
			  // universal module definition
			  /* jshint strict: false */ /*globals define, module, require */
			  if ( module.exports ) {
			    // CommonJS
			    module.exports = factory(
			      requireGetSize(),
			      requireOutlayer()
			    );
			  } else {
			    // browser global
			    window.Isotope = window.Isotope || {};
			    window.Isotope.LayoutMode = factory(
			      window.getSize,
			      window.Outlayer
			    );
			  }

			}( window, function factory( getSize, Outlayer ) {

			  // layout mode class
			  function LayoutMode( isotope ) {
			    this.isotope = isotope;
			    // link properties
			    if ( isotope ) {
			      this.options = isotope.options[ this.namespace ];
			      this.element = isotope.element;
			      this.items = isotope.filteredItems;
			      this.size = isotope.size;
			    }
			  }

			  var proto = LayoutMode.prototype;

			  /**
			   * some methods should just defer to default Outlayer method
			   * and reference the Isotope instance as `this`
			  **/
			  var facadeMethods = [
			    '_resetLayout',
			    '_getItemLayoutPosition',
			    '_manageStamp',
			    '_getContainerSize',
			    '_getElementOffset',
			    'needsResizeLayout',
			    '_getOption'
			  ];

			  facadeMethods.forEach( function( methodName ) {
			    proto[ methodName ] = function() {
			      return Outlayer.prototype[ methodName ].apply( this.isotope, arguments );
			    };
			  });

			  // -----  ----- //

			  // for horizontal layout modes, check vertical size
			  proto.needsVerticalResizeLayout = function() {
			    // don't trigger if size did not change
			    var size = getSize( this.isotope.element );
			    // check that this.size and size are there
			    // IE8 triggers resize on body size change, so they might not be
			    var hasSizes = this.isotope.size && size;
			    return hasSizes && size.innerHeight != this.isotope.size.innerHeight;
			  };

			  // ----- measurements ----- //

			  proto._getMeasurement = function() {
			    this.isotope._getMeasurement.apply( this, arguments );
			  };

			  proto.getColumnWidth = function() {
			    this.getSegmentSize( 'column', 'Width' );
			  };

			  proto.getRowHeight = function() {
			    this.getSegmentSize( 'row', 'Height' );
			  };

			  /**
			   * get columnWidth or rowHeight
			   * segment: 'column' or 'row'
			   * size 'Width' or 'Height'
			  **/
			  proto.getSegmentSize = function( segment, size ) {
			    var segmentName = segment + size;
			    var outerSize = 'outer' + size;
			    // columnWidth / outerWidth // rowHeight / outerHeight
			    this._getMeasurement( segmentName, outerSize );
			    // got rowHeight or columnWidth, we can chill
			    if ( this[ segmentName ] ) {
			      return;
			    }
			    // fall back to item of first element
			    var firstItemSize = this.getFirstItemSize();
			    this[ segmentName ] = firstItemSize && firstItemSize[ outerSize ] ||
			      // or size of container
			      this.isotope.size[ 'inner' + size ];
			  };

			  proto.getFirstItemSize = function() {
			    var firstItem = this.isotope.filteredItems[0];
			    return firstItem && firstItem.element && getSize( firstItem.element );
			  };

			  // ----- methods that should reference isotope ----- //

			  proto.layout = function() {
			    this.isotope.layout.apply( this.isotope, arguments );
			  };

			  proto.getSize = function() {
			    this.isotope.getSize();
			    this.size = this.isotope.size;
			  };

			  // -------------------------- create -------------------------- //

			  LayoutMode.modes = {};

			  LayoutMode.create = function( namespace, options ) {

			    function Mode() {
			      LayoutMode.apply( this, arguments );
			    }

			    Mode.prototype = Object.create( proto );
			    Mode.prototype.constructor = Mode;

			    // default options
			    if ( options ) {
			      Mode.options = options;
			    }

			    Mode.prototype.namespace = namespace;
			    // register in Isotope
			    LayoutMode.modes[ namespace ] = Mode;

			    return Mode;
			  };

			  return LayoutMode;

			}));
	} (layoutMode));
		return layoutMode.exports;
	}

	var masonry$1 = {exports: {}};

	var masonry = {exports: {}};

	/*!
	 * Masonry v4.2.2
	 * Cascading grid layout library
	 * https://masonry.desandro.com
	 * MIT License
	 * by David DeSandro
	 */

	var hasRequiredMasonry$1;

	function requireMasonry$1 () {
		if (hasRequiredMasonry$1) return masonry.exports;
		hasRequiredMasonry$1 = 1;
		(function (module) {
			( function( window, factory ) {
			  // universal module definition
			  /* jshint strict: false */ /*globals define, module, require */
			  if ( module.exports ) {
			    // CommonJS
			    module.exports = factory(
			      requireOutlayer(),
			      requireGetSize()
			    );
			  } else {
			    // browser global
			    window.Masonry = factory(
			      window.Outlayer,
			      window.getSize
			    );
			  }

			}( window, function factory( Outlayer, getSize ) {

			// -------------------------- masonryDefinition -------------------------- //

			  // create an Outlayer layout class
			  var Masonry = Outlayer.create('masonry');
			  // isFitWidth -> fitWidth
			  Masonry.compatOptions.fitWidth = 'isFitWidth';

			  var proto = Masonry.prototype;

			  proto._resetLayout = function() {
			    this.getSize();
			    this._getMeasurement( 'columnWidth', 'outerWidth' );
			    this._getMeasurement( 'gutter', 'outerWidth' );
			    this.measureColumns();

			    // reset column Y
			    this.colYs = [];
			    for ( var i=0; i < this.cols; i++ ) {
			      this.colYs.push( 0 );
			    }

			    this.maxY = 0;
			    this.horizontalColIndex = 0;
			  };

			  proto.measureColumns = function() {
			    this.getContainerWidth();
			    // if columnWidth is 0, default to outerWidth of first item
			    if ( !this.columnWidth ) {
			      var firstItem = this.items[0];
			      var firstItemElem = firstItem && firstItem.element;
			      // columnWidth fall back to item of first element
			      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
			        // if first elem has no width, default to size of container
			        this.containerWidth;
			    }

			    var columnWidth = this.columnWidth += this.gutter;

			    // calculate columns
			    var containerWidth = this.containerWidth + this.gutter;
			    var cols = containerWidth / columnWidth;
			    // fix rounding errors, typically with gutters
			    var excess = columnWidth - containerWidth % columnWidth;
			    // if overshoot is less than a pixel, round up, otherwise floor it
			    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
			    cols = Math[ mathMethod ]( cols );
			    this.cols = Math.max( cols, 1 );
			  };

			  proto.getContainerWidth = function() {
			    // container is parent if fit width
			    var isFitWidth = this._getOption('fitWidth');
			    var container = isFitWidth ? this.element.parentNode : this.element;
			    // check that this.size and size are there
			    // IE8 triggers resize on body size change, so they might not be
			    var size = getSize( container );
			    this.containerWidth = size && size.innerWidth;
			  };

			  proto._getItemLayoutPosition = function( item ) {
			    item.getSize();
			    // how many columns does this brick span
			    var remainder = item.size.outerWidth % this.columnWidth;
			    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
			    // round if off by 1 pixel, otherwise use ceil
			    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
			    colSpan = Math.min( colSpan, this.cols );
			    // use horizontal or top column position
			    var colPosMethod = this.options.horizontalOrder ?
			      '_getHorizontalColPosition' : '_getTopColPosition';
			    var colPosition = this[ colPosMethod ]( colSpan, item );
			    // position the brick
			    var position = {
			      x: this.columnWidth * colPosition.col,
			      y: colPosition.y
			    };
			    // apply setHeight to necessary columns
			    var setHeight = colPosition.y + item.size.outerHeight;
			    var setMax = colSpan + colPosition.col;
			    for ( var i = colPosition.col; i < setMax; i++ ) {
			      this.colYs[i] = setHeight;
			    }

			    return position;
			  };

			  proto._getTopColPosition = function( colSpan ) {
			    var colGroup = this._getTopColGroup( colSpan );
			    // get the minimum Y value from the columns
			    var minimumY = Math.min.apply( Math, colGroup );

			    return {
			      col: colGroup.indexOf( minimumY ),
			      y: minimumY,
			    };
			  };

			  /**
			   * @param {Number} colSpan - number of columns the element spans
			   * @returns {Array} colGroup
			   */
			  proto._getTopColGroup = function( colSpan ) {
			    if ( colSpan < 2 ) {
			      // if brick spans only one column, use all the column Ys
			      return this.colYs;
			    }

			    var colGroup = [];
			    // how many different places could this brick fit horizontally
			    var groupCount = this.cols + 1 - colSpan;
			    // for each group potential horizontal position
			    for ( var i = 0; i < groupCount; i++ ) {
			      colGroup[i] = this._getColGroupY( i, colSpan );
			    }
			    return colGroup;
			  };

			  proto._getColGroupY = function( col, colSpan ) {
			    if ( colSpan < 2 ) {
			      return this.colYs[ col ];
			    }
			    // make an array of colY values for that one group
			    var groupColYs = this.colYs.slice( col, col + colSpan );
			    // and get the max value of the array
			    return Math.max.apply( Math, groupColYs );
			  };

			  // get column position based on horizontal index. #873
			  proto._getHorizontalColPosition = function( colSpan, item ) {
			    var col = this.horizontalColIndex % this.cols;
			    var isOver = colSpan > 1 && col + colSpan > this.cols;
			    // shift to next row if item can't fit on current row
			    col = isOver ? 0 : col;
			    // don't let zero-size items take up space
			    var hasSize = item.size.outerWidth && item.size.outerHeight;
			    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;

			    return {
			      col: col,
			      y: this._getColGroupY( col, colSpan ),
			    };
			  };

			  proto._manageStamp = function( stamp ) {
			    var stampSize = getSize( stamp );
			    var offset = this._getElementOffset( stamp );
			    // get the columns that this stamp affects
			    var isOriginLeft = this._getOption('originLeft');
			    var firstX = isOriginLeft ? offset.left : offset.right;
			    var lastX = firstX + stampSize.outerWidth;
			    var firstCol = Math.floor( firstX / this.columnWidth );
			    firstCol = Math.max( 0, firstCol );
			    var lastCol = Math.floor( lastX / this.columnWidth );
			    // lastCol should not go over if multiple of columnWidth #425
			    lastCol -= lastX % this.columnWidth ? 0 : 1;
			    lastCol = Math.min( this.cols - 1, lastCol );
			    // set colYs to bottom of the stamp

			    var isOriginTop = this._getOption('originTop');
			    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
			      stampSize.outerHeight;
			    for ( var i = firstCol; i <= lastCol; i++ ) {
			      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
			    }
			  };

			  proto._getContainerSize = function() {
			    this.maxY = Math.max.apply( Math, this.colYs );
			    var size = {
			      height: this.maxY
			    };

			    if ( this._getOption('fitWidth') ) {
			      size.width = this._getContainerFitWidth();
			    }

			    return size;
			  };

			  proto._getContainerFitWidth = function() {
			    var unusedCols = 0;
			    // count unused columns
			    var i = this.cols;
			    while ( --i ) {
			      if ( this.colYs[i] !== 0 ) {
			        break;
			      }
			      unusedCols++;
			    }
			    // fit container to columns that have been used
			    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
			  };

			  proto.needsResizeLayout = function() {
			    var previousWidth = this.containerWidth;
			    this.getContainerWidth();
			    return previousWidth != this.containerWidth;
			  };

			  return Masonry;

			}));
	} (masonry));
		return masonry.exports;
	}

	/*!
	 * Masonry layout mode
	 * sub-classes Masonry
	 * https://masonry.desandro.com
	 */

	var hasRequiredMasonry;

	function requireMasonry () {
		if (hasRequiredMasonry) return masonry$1.exports;
		hasRequiredMasonry = 1;
		(function (module) {
			( function( window, factory ) {
			  // universal module definition
			  /* jshint strict: false */ /*globals define, module, require */
			  if ( module.exports ) {
			    // CommonJS
			    module.exports = factory(
			      requireLayoutMode(),
			      requireMasonry$1()
			    );
			  } else {
			    // browser global
			    factory(
			      window.Isotope.LayoutMode,
			      window.Masonry
			    );
			  }

			}( window, function factory( LayoutMode, Masonry ) {

			// -------------------------- masonryDefinition -------------------------- //

			  // create an Outlayer layout class
			  var MasonryMode = LayoutMode.create('masonry');

			  var proto = MasonryMode.prototype;

			  var keepModeMethods = {
			    _getElementOffset: true,
			    layout: true,
			    _getMeasurement: true
			  };

			  // inherit Masonry prototype
			  for ( var method in Masonry.prototype ) {
			    // do not inherit mode methods
			    if ( !keepModeMethods[ method ] ) {
			      proto[ method ] = Masonry.prototype[ method ];
			    }
			  }

			  var measureColumns = proto.measureColumns;
			  proto.measureColumns = function() {
			    // set items, used if measuring first item
			    this.items = this.isotope.filteredItems;
			    measureColumns.call( this );
			  };

			  // point to mode options for fitWidth
			  var _getOption = proto._getOption;
			  proto._getOption = function( option ) {
			    if ( option == 'fitWidth' ) {
			      return this.options.isFitWidth !== undefined ?
			        this.options.isFitWidth : this.options.fitWidth;
			    }
			    return _getOption.apply( this.isotope, arguments );
			  };

			  return MasonryMode;

			}));
	} (masonry$1));
		return masonry$1.exports;
	}

	var fitRows = {exports: {}};

	/**
	 * fitRows layout mode
	 */

	var hasRequiredFitRows;

	function requireFitRows () {
		if (hasRequiredFitRows) return fitRows.exports;
		hasRequiredFitRows = 1;
		(function (module, exports) {
			( function( window, factory ) {
			  // universal module definition
			  /* jshint strict: false */ /*globals define, module, require */
			  {
			    // CommonJS
			    module.exports = factory(
			      requireLayoutMode()
			    );
			  }

			}( window, function factory( LayoutMode ) {

			var FitRows = LayoutMode.create('fitRows');

			var proto = FitRows.prototype;

			proto._resetLayout = function() {
			  this.x = 0;
			  this.y = 0;
			  this.maxY = 0;
			  this._getMeasurement( 'gutter', 'outerWidth' );
			};

			proto._getItemLayoutPosition = function( item ) {
			  item.getSize();

			  var itemWidth = item.size.outerWidth + this.gutter;
			  // if this element cannot fit in the current row
			  var containerWidth = this.isotope.size.innerWidth + this.gutter;
			  if ( this.x !== 0 && itemWidth + this.x > containerWidth ) {
			    this.x = 0;
			    this.y = this.maxY;
			  }

			  var position = {
			    x: this.x,
			    y: this.y
			  };

			  this.maxY = Math.max( this.maxY, this.y + item.size.outerHeight );
			  this.x += itemWidth;

			  return position;
			};

			proto._getContainerSize = function() {
			  return { height: this.maxY };
			};

			return FitRows;

			}));
	} (fitRows));
		return fitRows.exports;
	}

	var vertical = {exports: {}};

	/**
	 * vertical layout mode
	 */

	var hasRequiredVertical;

	function requireVertical () {
		if (hasRequiredVertical) return vertical.exports;
		hasRequiredVertical = 1;
		(function (module) {
			( function( window, factory ) {
			  // universal module definition
			  /* jshint strict: false */ /*globals define, module, require */
			  if ( module.exports ) {
			    // CommonJS
			    module.exports = factory(
			      requireLayoutMode()
			    );
			  } else {
			    // browser global
			    factory(
			      window.Isotope.LayoutMode
			    );
			  }

			}( window, function factory( LayoutMode ) {

			var Vertical = LayoutMode.create( 'vertical', {
			  horizontalAlignment: 0
			});

			var proto = Vertical.prototype;

			proto._resetLayout = function() {
			  this.y = 0;
			};

			proto._getItemLayoutPosition = function( item ) {
			  item.getSize();
			  var x = ( this.isotope.size.innerWidth - item.size.outerWidth ) *
			    this.options.horizontalAlignment;
			  var y = this.y;
			  this.y += item.size.outerHeight;
			  return { x: x, y: y };
			};

			proto._getContainerSize = function() {
			  return { height: this.y };
			};

			return Vertical;

			}));
	} (vertical));
		return vertical.exports;
	}

	/*!
	 * Isotope v3.0.6
	 *
	 * Licensed GPLv3 for open source use
	 * or Isotope Commercial License for commercial use
	 *
	 * https://isotope.metafizzy.co
	 * Copyright 2010-2018 Metafizzy
	 */

	(function (module) {
		( function( window, factory ) {
		  // universal module definition
		  /* jshint strict: false */ /*globals define, module, require */
		  if ( module.exports ) {
		    // CommonJS
		    module.exports = factory(
		      window,
		      requireOutlayer(),
		      requireGetSize(),
		      requireMatchesSelector(),
		      requireUtils(),
		      requireItem(),
		      requireLayoutMode(),
		      // include default layout modes
		      requireMasonry(),
		      requireFitRows(),
		      requireVertical()
		    );
		  } else {
		    // browser global
		    window.Isotope = factory(
		      window,
		      window.Outlayer,
		      window.getSize,
		      window.matchesSelector,
		      window.fizzyUIUtils,
		      window.Isotope.Item,
		      window.Isotope.LayoutMode
		    );
		  }

		}( window, function factory( window, Outlayer, getSize, matchesSelector, utils,
		  Item, LayoutMode ) {

		// -------------------------- vars -------------------------- //

		var jQuery = window.jQuery;

		// -------------------------- helpers -------------------------- //

		var trim = String.prototype.trim ?
		  function( str ) {
		    return str.trim();
		  } :
		  function( str ) {
		    return str.replace( /^\s+|\s+$/g, '' );
		  };

		// -------------------------- isotopeDefinition -------------------------- //

		  // create an Outlayer layout class
		  var Isotope = Outlayer.create( 'isotope', {
		    layoutMode: 'masonry',
		    isJQueryFiltering: true,
		    sortAscending: true
		  });

		  Isotope.Item = Item;
		  Isotope.LayoutMode = LayoutMode;

		  var proto = Isotope.prototype;

		  proto._create = function() {
		    this.itemGUID = 0;
		    // functions that sort items
		    this._sorters = {};
		    this._getSorters();
		    // call super
		    Outlayer.prototype._create.call( this );

		    // create layout modes
		    this.modes = {};
		    // start filteredItems with all items
		    this.filteredItems = this.items;
		    // keep of track of sortBys
		    this.sortHistory = [ 'original-order' ];
		    // create from registered layout modes
		    for ( var name in LayoutMode.modes ) {
		      this._initLayoutMode( name );
		    }
		  };

		  proto.reloadItems = function() {
		    // reset item ID counter
		    this.itemGUID = 0;
		    // call super
		    Outlayer.prototype.reloadItems.call( this );
		  };

		  proto._itemize = function() {
		    var items = Outlayer.prototype._itemize.apply( this, arguments );
		    // assign ID for original-order
		    for ( var i=0; i < items.length; i++ ) {
		      var item = items[i];
		      item.id = this.itemGUID++;
		    }
		    this._updateItemsSortData( items );
		    return items;
		  };


		  // -------------------------- layout -------------------------- //

		  proto._initLayoutMode = function( name ) {
		    var Mode = LayoutMode.modes[ name ];
		    // set mode options
		    // HACK extend initial options, back-fill in default options
		    var initialOpts = this.options[ name ] || {};
		    this.options[ name ] = Mode.options ?
		      utils.extend( Mode.options, initialOpts ) : initialOpts;
		    // init layout mode instance
		    this.modes[ name ] = new Mode( this );
		  };


		  proto.layout = function() {
		    // if first time doing layout, do all magic
		    if ( !this._isLayoutInited && this._getOption('initLayout') ) {
		      this.arrange();
		      return;
		    }
		    this._layout();
		  };

		  // private method to be used in layout() & magic()
		  proto._layout = function() {
		    // don't animate first layout
		    var isInstant = this._getIsInstant();
		    // layout flow
		    this._resetLayout();
		    this._manageStamps();
		    this.layoutItems( this.filteredItems, isInstant );

		    // flag for initalized
		    this._isLayoutInited = true;
		  };

		  // filter + sort + layout
		  proto.arrange = function( opts ) {
		    // set any options pass
		    this.option( opts );
		    this._getIsInstant();
		    // filter, sort, and layout

		    // filter
		    var filtered = this._filter( this.items );
		    this.filteredItems = filtered.matches;

		    this._bindArrangeComplete();

		    if ( this._isInstant ) {
		      this._noTransition( this._hideReveal, [ filtered ] );
		    } else {
		      this._hideReveal( filtered );
		    }

		    this._sort();
		    this._layout();
		  };
		  // alias to _init for main plugin method
		  proto._init = proto.arrange;

		  proto._hideReveal = function( filtered ) {
		    this.reveal( filtered.needReveal );
		    this.hide( filtered.needHide );
		  };

		  // HACK
		  // Don't animate/transition first layout
		  // Or don't animate/transition other layouts
		  proto._getIsInstant = function() {
		    var isLayoutInstant = this._getOption('layoutInstant');
		    var isInstant = isLayoutInstant !== undefined ? isLayoutInstant :
		      !this._isLayoutInited;
		    this._isInstant = isInstant;
		    return isInstant;
		  };

		  // listen for layoutComplete, hideComplete and revealComplete
		  // to trigger arrangeComplete
		  proto._bindArrangeComplete = function() {
		    // listen for 3 events to trigger arrangeComplete
		    var isLayoutComplete, isHideComplete, isRevealComplete;
		    var _this = this;
		    function arrangeParallelCallback() {
		      if ( isLayoutComplete && isHideComplete && isRevealComplete ) {
		        _this.dispatchEvent( 'arrangeComplete', null, [ _this.filteredItems ] );
		      }
		    }
		    this.once( 'layoutComplete', function() {
		      isLayoutComplete = true;
		      arrangeParallelCallback();
		    });
		    this.once( 'hideComplete', function() {
		      isHideComplete = true;
		      arrangeParallelCallback();
		    });
		    this.once( 'revealComplete', function() {
		      isRevealComplete = true;
		      arrangeParallelCallback();
		    });
		  };

		  // -------------------------- filter -------------------------- //

		  proto._filter = function( items ) {
		    var filter = this.options.filter;
		    filter = filter || '*';
		    var matches = [];
		    var hiddenMatched = [];
		    var visibleUnmatched = [];

		    var test = this._getFilterTest( filter );

		    // test each item
		    for ( var i=0; i < items.length; i++ ) {
		      var item = items[i];
		      if ( item.isIgnored ) {
		        continue;
		      }
		      // add item to either matched or unmatched group
		      var isMatched = test( item );
		      // item.isFilterMatched = isMatched;
		      // add to matches if its a match
		      if ( isMatched ) {
		        matches.push( item );
		      }
		      // add to additional group if item needs to be hidden or revealed
		      if ( isMatched && item.isHidden ) {
		        hiddenMatched.push( item );
		      } else if ( !isMatched && !item.isHidden ) {
		        visibleUnmatched.push( item );
		      }
		    }

		    // return collections of items to be manipulated
		    return {
		      matches: matches,
		      needReveal: hiddenMatched,
		      needHide: visibleUnmatched
		    };
		  };

		  // get a jQuery, function, or a matchesSelector test given the filter
		  proto._getFilterTest = function( filter ) {
		    if ( jQuery && this.options.isJQueryFiltering ) {
		      // use jQuery
		      return function( item ) {
		        return jQuery( item.element ).is( filter );
		      };
		    }
		    if ( typeof filter == 'function' ) {
		      // use filter as function
		      return function( item ) {
		        return filter( item.element );
		      };
		    }
		    // default, use filter as selector string
		    return function( item ) {
		      return matchesSelector( item.element, filter );
		    };
		  };

		  // -------------------------- sorting -------------------------- //

		  /**
		   * @params {Array} elems
		   * @public
		   */
		  proto.updateSortData = function( elems ) {
		    // get items
		    var items;
		    if ( elems ) {
		      elems = utils.makeArray( elems );
		      items = this.getItems( elems );
		    } else {
		      // update all items if no elems provided
		      items = this.items;
		    }

		    this._getSorters();
		    this._updateItemsSortData( items );
		  };

		  proto._getSorters = function() {
		    var getSortData = this.options.getSortData;
		    for ( var key in getSortData ) {
		      var sorter = getSortData[ key ];
		      this._sorters[ key ] = mungeSorter( sorter );
		    }
		  };

		  /**
		   * @params {Array} items - of Isotope.Items
		   * @private
		   */
		  proto._updateItemsSortData = function( items ) {
		    // do not update if no items
		    var len = items && items.length;

		    for ( var i=0; len && i < len; i++ ) {
		      var item = items[i];
		      item.updateSortData();
		    }
		  };

		  // ----- munge sorter ----- //

		  // encapsulate this, as we just need mungeSorter
		  // other functions in here are just for munging
		  var mungeSorter = ( function() {
		    // add a magic layer to sorters for convienent shorthands
		    // `.foo-bar` will use the text of .foo-bar querySelector
		    // `[foo-bar]` will use attribute
		    // you can also add parser
		    // `.foo-bar parseInt` will parse that as a number
		    function mungeSorter( sorter ) {
		      // if not a string, return function or whatever it is
		      if ( typeof sorter != 'string' ) {
		        return sorter;
		      }
		      // parse the sorter string
		      var args = trim( sorter ).split(' ');
		      var query = args[0];
		      // check if query looks like [an-attribute]
		      var attrMatch = query.match( /^\[(.+)\]$/ );
		      var attr = attrMatch && attrMatch[1];
		      var getValue = getValueGetter( attr, query );
		      // use second argument as a parser
		      var parser = Isotope.sortDataParsers[ args[1] ];
		      // parse the value, if there was a parser
		      sorter = parser ? function( elem ) {
		        return elem && parser( getValue( elem ) );
		      } :
		      // otherwise just return value
		      function( elem ) {
		        return elem && getValue( elem );
		      };

		      return sorter;
		    }

		    // get an attribute getter, or get text of the querySelector
		    function getValueGetter( attr, query ) {
		      // if query looks like [foo-bar], get attribute
		      if ( attr ) {
		        return function getAttribute( elem ) {
		          return elem.getAttribute( attr );
		        };
		      }

		      // otherwise, assume its a querySelector, and get its text
		      return function getChildText( elem ) {
		        var child = elem.querySelector( query );
		        return child && child.textContent;
		      };
		    }

		    return mungeSorter;
		  })();

		  // parsers used in getSortData shortcut strings
		  Isotope.sortDataParsers = {
		    'parseInt': function( val ) {
		      return parseInt( val, 10 );
		    },
		    'parseFloat': function( val ) {
		      return parseFloat( val );
		    }
		  };

		  // ----- sort method ----- //

		  // sort filteredItem order
		  proto._sort = function() {
		    if ( !this.options.sortBy ) {
		      return;
		    }
		    // keep track of sortBy History
		    var sortBys = utils.makeArray( this.options.sortBy );
		    if ( !this._getIsSameSortBy( sortBys ) ) {
		      // concat all sortBy and sortHistory, add to front, oldest goes in last
		      this.sortHistory = sortBys.concat( this.sortHistory );
		    }
		    // sort magic
		    var itemSorter = getItemSorter( this.sortHistory, this.options.sortAscending );
		    this.filteredItems.sort( itemSorter );
		  };

		  // check if sortBys is same as start of sortHistory
		  proto._getIsSameSortBy = function( sortBys ) {
		    for ( var i=0; i < sortBys.length; i++ ) {
		      if ( sortBys[i] != this.sortHistory[i] ) {
		        return false;
		      }
		    }
		    return true;
		  };

		  // returns a function used for sorting
		  function getItemSorter( sortBys, sortAsc ) {
		    return function sorter( itemA, itemB ) {
		      // cycle through all sortKeys
		      for ( var i = 0; i < sortBys.length; i++ ) {
		        var sortBy = sortBys[i];
		        var a = itemA.sortData[ sortBy ];
		        var b = itemB.sortData[ sortBy ];
		        if ( a > b || a < b ) {
		          // if sortAsc is an object, use the value given the sortBy key
		          var isAscending = sortAsc[ sortBy ] !== undefined ? sortAsc[ sortBy ] : sortAsc;
		          var direction = isAscending ? 1 : -1;
		          return ( a > b ? 1 : -1 ) * direction;
		        }
		      }
		      return 0;
		    };
		  }

		  // -------------------------- methods -------------------------- //

		  // get layout mode
		  proto._mode = function() {
		    var layoutMode = this.options.layoutMode;
		    var mode = this.modes[ layoutMode ];
		    if ( !mode ) {
		      // TODO console.error
		      throw new Error( 'No layout mode: ' + layoutMode );
		    }
		    // HACK sync mode's options
		    // any options set after init for layout mode need to be synced
		    mode.options = this.options[ layoutMode ];
		    return mode;
		  };

		  proto._resetLayout = function() {
		    // trigger original reset layout
		    Outlayer.prototype._resetLayout.call( this );
		    this._mode()._resetLayout();
		  };

		  proto._getItemLayoutPosition = function( item  ) {
		    return this._mode()._getItemLayoutPosition( item );
		  };

		  proto._manageStamp = function( stamp ) {
		    this._mode()._manageStamp( stamp );
		  };

		  proto._getContainerSize = function() {
		    return this._mode()._getContainerSize();
		  };

		  proto.needsResizeLayout = function() {
		    return this._mode().needsResizeLayout();
		  };

		  // -------------------------- adding & removing -------------------------- //

		  // HEADS UP overwrites default Outlayer appended
		  proto.appended = function( elems ) {
		    var items = this.addItems( elems );
		    if ( !items.length ) {
		      return;
		    }
		    // filter, layout, reveal new items
		    var filteredItems = this._filterRevealAdded( items );
		    // add to filteredItems
		    this.filteredItems = this.filteredItems.concat( filteredItems );
		  };

		  // HEADS UP overwrites default Outlayer prepended
		  proto.prepended = function( elems ) {
		    var items = this._itemize( elems );
		    if ( !items.length ) {
		      return;
		    }
		    // start new layout
		    this._resetLayout();
		    this._manageStamps();
		    // filter, layout, reveal new items
		    var filteredItems = this._filterRevealAdded( items );
		    // layout previous items
		    this.layoutItems( this.filteredItems );
		    // add to items and filteredItems
		    this.filteredItems = filteredItems.concat( this.filteredItems );
		    this.items = items.concat( this.items );
		  };

		  proto._filterRevealAdded = function( items ) {
		    var filtered = this._filter( items );
		    this.hide( filtered.needHide );
		    // reveal all new items
		    this.reveal( filtered.matches );
		    // layout new items, no transition
		    this.layoutItems( filtered.matches, true );
		    return filtered.matches;
		  };

		  /**
		   * Filter, sort, and layout newly-appended item elements
		   * @param {Array or NodeList or Element} elems
		   */
		  proto.insert = function( elems ) {
		    var items = this.addItems( elems );
		    if ( !items.length ) {
		      return;
		    }
		    // append item elements
		    var i, item;
		    var len = items.length;
		    for ( i=0; i < len; i++ ) {
		      item = items[i];
		      this.element.appendChild( item.element );
		    }
		    // filter new stuff
		    var filteredInsertItems = this._filter( items ).matches;
		    // set flag
		    for ( i=0; i < len; i++ ) {
		      items[i].isLayoutInstant = true;
		    }
		    this.arrange();
		    // reset flag
		    for ( i=0; i < len; i++ ) {
		      delete items[i].isLayoutInstant;
		    }
		    this.reveal( filteredInsertItems );
		  };

		  var _remove = proto.remove;
		  proto.remove = function( elems ) {
		    elems = utils.makeArray( elems );
		    var removeItems = this.getItems( elems );
		    // do regular thing
		    _remove.call( this, elems );
		    // bail if no items to remove
		    var len = removeItems && removeItems.length;
		    // remove elems from filteredItems
		    for ( var i=0; len && i < len; i++ ) {
		      var item = removeItems[i];
		      // remove item from collection
		      utils.removeFrom( this.filteredItems, item );
		    }
		  };

		  proto.shuffle = function() {
		    // update random sortData
		    for ( var i=0; i < this.items.length; i++ ) {
		      var item = this.items[i];
		      item.sortData.random = Math.random();
		    }
		    this.options.sortBy = 'random';
		    this._sort();
		    this._layout();
		  };

		  /**
		   * trigger fn without transition
		   * kind of hacky to have this in the first place
		   * @param {Function} fn
		   * @param {Array} args
		   * @returns ret
		   * @private
		   */
		  proto._noTransition = function( fn, args ) {
		    // save transitionDuration before disabling
		    var transitionDuration = this.options.transitionDuration;
		    // disable transition
		    this.options.transitionDuration = 0;
		    // do it
		    var returnValue = fn.apply( this, args );
		    // re-enable transition for reveal
		    this.options.transitionDuration = transitionDuration;
		    return returnValue;
		  };

		  // ----- helper methods ----- //

		  /**
		   * getter method for getting filtered item elements
		   * @returns {Array} elems - collection of item elements
		   */
		  proto.getFilteredItemElements = function() {
		    return this.filteredItems.map( function( item ) {
		      return item.element;
		    });
		  };

		  // -----  ----- //

		  return Isotope;

		}));
	} (isotope));

	var Isotope = isotope.exports;

	var imagesloaded = {exports: {}};

	var evEmitter = {exports: {}};

	/**
	 * EvEmitter v2.1.1
	 * Lil' event emitter
	 * MIT License
	 */

	var hasRequiredEvEmitter;

	function requireEvEmitter () {
		if (hasRequiredEvEmitter) return evEmitter.exports;
		hasRequiredEvEmitter = 1;
		(function (module) {
			( function( global, factory ) {
			  // universal module definition
			  if ( module.exports ) {
			    // CommonJS - Browserify, Webpack
			    module.exports = factory();
			  } else {
			    // Browser globals
			    global.EvEmitter = factory();
			  }

			}( typeof window != 'undefined' ? window : commonjsGlobal, function() {

			function EvEmitter() {}

			let proto = EvEmitter.prototype;

			proto.on = function( eventName, listener ) {
			  if ( !eventName || !listener ) return this;

			  // set events hash
			  let events = this._events = this._events || {};
			  // set listeners array
			  let listeners = events[ eventName ] = events[ eventName ] || [];
			  // only add once
			  if ( !listeners.includes( listener ) ) {
			    listeners.push( listener );
			  }

			  return this;
			};

			proto.once = function( eventName, listener ) {
			  if ( !eventName || !listener ) return this;

			  // add event
			  this.on( eventName, listener );
			  // set once flag
			  // set onceEvents hash
			  let onceEvents = this._onceEvents = this._onceEvents || {};
			  // set onceListeners object
			  let onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
			  // set flag
			  onceListeners[ listener ] = true;

			  return this;
			};

			proto.off = function( eventName, listener ) {
			  let listeners = this._events && this._events[ eventName ];
			  if ( !listeners || !listeners.length ) return this;

			  let index = listeners.indexOf( listener );
			  if ( index != -1 ) {
			    listeners.splice( index, 1 );
			  }

			  return this;
			};

			proto.emitEvent = function( eventName, args ) {
			  let listeners = this._events && this._events[ eventName ];
			  if ( !listeners || !listeners.length ) return this;

			  // copy over to avoid interference if .off() in listener
			  listeners = listeners.slice( 0 );
			  args = args || [];
			  // once stuff
			  let onceListeners = this._onceEvents && this._onceEvents[ eventName ];

			  for ( let listener of listeners ) {
			    let isOnce = onceListeners && onceListeners[ listener ];
			    if ( isOnce ) {
			      // remove listener
			      // remove before trigger to prevent recursion
			      this.off( eventName, listener );
			      // unset once flag
			      delete onceListeners[ listener ];
			    }
			    // trigger listener
			    listener.apply( this, args );
			  }

			  return this;
			};

			proto.allOff = function() {
			  delete this._events;
			  delete this._onceEvents;
			  return this;
			};

			return EvEmitter;

			} ) );
	} (evEmitter));
		return evEmitter.exports;
	}

	/*!
	 * imagesLoaded v5.0.0
	 * JavaScript is all like "You images are done yet or what?"
	 * MIT License
	 */

	(function (module) {
		( function( window, factory ) {
		  // universal module definition
		  if ( module.exports ) {
		    // CommonJS
		    module.exports = factory( window, requireEvEmitter() );
		  } else {
		    // browser global
		    window.imagesLoaded = factory( window, window.EvEmitter );
		  }

		} )( typeof window !== 'undefined' ? window : commonjsGlobal,
		    function factory( window, EvEmitter ) {

		let $ = window.jQuery;
		let console = window.console;

		// -------------------------- helpers -------------------------- //

		// turn element or nodeList into an array
		function makeArray( obj ) {
		  // use object if already an array
		  if ( Array.isArray( obj ) ) return obj;

		  let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
		  // convert nodeList to array
		  if ( isArrayLike ) return [ ...obj ];

		  // array of single index
		  return [ obj ];
		}

		// -------------------------- imagesLoaded -------------------------- //

		/**
		 * @param {[Array, Element, NodeList, String]} elem
		 * @param {[Object, Function]} options - if function, use as callback
		 * @param {Function} onAlways - callback function
		 * @returns {ImagesLoaded}
		 */
		function ImagesLoaded( elem, options, onAlways ) {
		  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
		  if ( !( this instanceof ImagesLoaded ) ) {
		    return new ImagesLoaded( elem, options, onAlways );
		  }
		  // use elem as selector string
		  let queryElem = elem;
		  if ( typeof elem == 'string' ) {
		    queryElem = document.querySelectorAll( elem );
		  }
		  // bail if bad element
		  if ( !queryElem ) {
		    console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
		    return;
		  }

		  this.elements = makeArray( queryElem );
		  this.options = {};
		  // shift arguments if no options set
		  if ( typeof options == 'function' ) {
		    onAlways = options;
		  } else {
		    Object.assign( this.options, options );
		  }

		  if ( onAlways ) this.on( 'always', onAlways );

		  this.getImages();
		  // add jQuery Deferred object
		  if ( $ ) this.jqDeferred = new $.Deferred();

		  // HACK check async to allow time to bind listeners
		  setTimeout( this.check.bind( this ) );
		}

		ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

		ImagesLoaded.prototype.getImages = function() {
		  this.images = [];

		  // filter & find items if we have an item selector
		  this.elements.forEach( this.addElementImages, this );
		};

		const elementNodeTypes = [ 1, 9, 11 ];

		/**
		 * @param {Node} elem
		 */
		ImagesLoaded.prototype.addElementImages = function( elem ) {
		  // filter siblings
		  if ( elem.nodeName === 'IMG' ) {
		    this.addImage( elem );
		  }
		  // get background image on element
		  if ( this.options.background === true ) {
		    this.addElementBackgroundImages( elem );
		  }

		  // find children
		  // no non-element nodes, #143
		  let { nodeType } = elem;
		  if ( !nodeType || !elementNodeTypes.includes( nodeType ) ) return;

		  let childImgs = elem.querySelectorAll('img');
		  // concat childElems to filterFound array
		  for ( let img of childImgs ) {
		    this.addImage( img );
		  }

		  // get child background images
		  if ( typeof this.options.background == 'string' ) {
		    let children = elem.querySelectorAll( this.options.background );
		    for ( let child of children ) {
		      this.addElementBackgroundImages( child );
		    }
		  }
		};

		const reURL = /url\((['"])?(.*?)\1\)/gi;

		ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
		  let style = getComputedStyle( elem );
		  // Firefox returns null if in a hidden iframe https://bugzil.la/548397
		  if ( !style ) return;

		  // get url inside url("...")
		  let matches = reURL.exec( style.backgroundImage );
		  while ( matches !== null ) {
		    let url = matches && matches[2];
		    if ( url ) {
		      this.addBackground( url, elem );
		    }
		    matches = reURL.exec( style.backgroundImage );
		  }
		};

		/**
		 * @param {Image} img
		 */
		ImagesLoaded.prototype.addImage = function( img ) {
		  let loadingImage = new LoadingImage( img );
		  this.images.push( loadingImage );
		};

		ImagesLoaded.prototype.addBackground = function( url, elem ) {
		  let background = new Background( url, elem );
		  this.images.push( background );
		};

		ImagesLoaded.prototype.check = function() {
		  this.progressedCount = 0;
		  this.hasAnyBroken = false;
		  // complete if no images
		  if ( !this.images.length ) {
		    this.complete();
		    return;
		  }

		  /* eslint-disable-next-line func-style */
		  let onProgress = ( image, elem, message ) => {
		    // HACK - Chrome triggers event before object properties have changed. #83
		    setTimeout( () => {
		      this.progress( image, elem, message );
		    } );
		  };

		  this.images.forEach( function( loadingImage ) {
		    loadingImage.once( 'progress', onProgress );
		    loadingImage.check();
		  } );
		};

		ImagesLoaded.prototype.progress = function( image, elem, message ) {
		  this.progressedCount++;
		  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
		  // progress event
		  this.emitEvent( 'progress', [ this, image, elem ] );
		  if ( this.jqDeferred && this.jqDeferred.notify ) {
		    this.jqDeferred.notify( this, image );
		  }
		  // check if completed
		  if ( this.progressedCount === this.images.length ) {
		    this.complete();
		  }

		  if ( this.options.debug && console ) {
		    console.log( `progress: ${message}`, image, elem );
		  }
		};

		ImagesLoaded.prototype.complete = function() {
		  let eventName = this.hasAnyBroken ? 'fail' : 'done';
		  this.isComplete = true;
		  this.emitEvent( eventName, [ this ] );
		  this.emitEvent( 'always', [ this ] );
		  if ( this.jqDeferred ) {
		    let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
		    this.jqDeferred[ jqMethod ]( this );
		  }
		};

		// --------------------------  -------------------------- //

		function LoadingImage( img ) {
		  this.img = img;
		}

		LoadingImage.prototype = Object.create( EvEmitter.prototype );

		LoadingImage.prototype.check = function() {
		  // If complete is true and browser supports natural sizes,
		  // try to check for image status manually.
		  let isComplete = this.getIsImageComplete();
		  if ( isComplete ) {
		    // report based on naturalWidth
		    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
		    return;
		  }

		  // If none of the checks above matched, simulate loading on detached element.
		  this.proxyImage = new Image();
		  // add crossOrigin attribute. #204
		  if ( this.img.crossOrigin ) {
		    this.proxyImage.crossOrigin = this.img.crossOrigin;
		  }
		  this.proxyImage.addEventListener( 'load', this );
		  this.proxyImage.addEventListener( 'error', this );
		  // bind to image as well for Firefox. #191
		  this.img.addEventListener( 'load', this );
		  this.img.addEventListener( 'error', this );
		  this.proxyImage.src = this.img.currentSrc || this.img.src;
		};

		LoadingImage.prototype.getIsImageComplete = function() {
		  // check for non-zero, non-undefined naturalWidth
		  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
		  return this.img.complete && this.img.naturalWidth;
		};

		LoadingImage.prototype.confirm = function( isLoaded, message ) {
		  this.isLoaded = isLoaded;
		  let { parentNode } = this.img;
		  // emit progress with parent <picture> or self <img>
		  let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
		  this.emitEvent( 'progress', [ this, elem, message ] );
		};

		// ----- events ----- //

		// trigger specified handler for event type
		LoadingImage.prototype.handleEvent = function( event ) {
		  let method = 'on' + event.type;
		  if ( this[ method ] ) {
		    this[ method ]( event );
		  }
		};

		LoadingImage.prototype.onload = function() {
		  this.confirm( true, 'onload' );
		  this.unbindEvents();
		};

		LoadingImage.prototype.onerror = function() {
		  this.confirm( false, 'onerror' );
		  this.unbindEvents();
		};

		LoadingImage.prototype.unbindEvents = function() {
		  this.proxyImage.removeEventListener( 'load', this );
		  this.proxyImage.removeEventListener( 'error', this );
		  this.img.removeEventListener( 'load', this );
		  this.img.removeEventListener( 'error', this );
		};

		// -------------------------- Background -------------------------- //

		function Background( url, element ) {
		  this.url = url;
		  this.element = element;
		  this.img = new Image();
		}

		// inherit LoadingImage prototype
		Background.prototype = Object.create( LoadingImage.prototype );

		Background.prototype.check = function() {
		  this.img.addEventListener( 'load', this );
		  this.img.addEventListener( 'error', this );
		  this.img.src = this.url;
		  // check if image is already complete
		  let isComplete = this.getIsImageComplete();
		  if ( isComplete ) {
		    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
		    this.unbindEvents();
		  }
		};

		Background.prototype.unbindEvents = function() {
		  this.img.removeEventListener( 'load', this );
		  this.img.removeEventListener( 'error', this );
		};

		Background.prototype.confirm = function( isLoaded, message ) {
		  this.isLoaded = isLoaded;
		  this.emitEvent( 'progress', [ this, this.element, message ] );
		};

		// -------------------------- jQuery -------------------------- //

		ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
		  jQuery = jQuery || window.jQuery;
		  if ( !jQuery ) return;

		  // set local variable
		  $ = jQuery;
		  // $().imagesLoaded()
		  $.fn.imagesLoaded = function( options, onAlways ) {
		    let instance = new ImagesLoaded( this, options, onAlways );
		    return instance.jqDeferred.promise( $( this ) );
		  };
		};
		// try making plugin
		ImagesLoaded.makeJQueryPlugin();

		// --------------------------  -------------------------- //

		return ImagesLoaded;

		} );
	} (imagesloaded));

	var imagesLoaded = imagesloaded.exports;

	var lgUtils = {};

	var hasRequiredLgUtils;

	function requireLgUtils () {
		if (hasRequiredLgUtils) return lgUtils;
		hasRequiredLgUtils = 1;
		(function (exports) {
			(function (global, factory) {
			    {
			        factory(exports);
			    }
			})(commonjsGlobal, function (exports) {

			    Object.defineProperty(exports, "__esModule", {
			        value: true
			    });

			    var utils = {
			        getAttribute: function getAttribute(el, label) {
			            return el[label];
			        },

			        setAttribute: function setAttribute(el, label, value) {
			            el[label] = value;
			        },
			        wrap: function wrap(el, className) {
			            if (!el) {
			                return;
			            }

			            var wrapper = document.createElement('div');
			            wrapper.className = className;
			            el.parentNode.insertBefore(wrapper, el);
			            el.parentNode.removeChild(el);
			            wrapper.appendChild(el);
			        },

			        addClass: function addClass(el, className) {
			            if (!el) {
			                return;
			            }

			            if (el.classList) {
			                el.classList.add(className);
			            } else {
			                el.className += ' ' + className;
			            }
			        },

			        removeClass: function removeClass(el, className) {
			            if (!el) {
			                return;
			            }

			            if (el.classList) {
			                el.classList.remove(className);
			            } else {
			                el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			            }
			        },

			        hasClass: function hasClass(el, className) {
			            if (el.classList) {
			                return el.classList.contains(className);
			            } else {
			                return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
			            }
			        },

			        // ex Transform
			        // ex TransitionTimingFunction
			        setVendor: function setVendor(el, property, value) {
			            if (!el) {
			                return;
			            }

			            el.style[property.charAt(0).toLowerCase() + property.slice(1)] = value;
			            el.style['webkit' + property] = value;
			            el.style['moz' + property] = value;
			            el.style['ms' + property] = value;
			            el.style['o' + property] = value;
			        },

			        trigger: function trigger(el, event) {
			            var detail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

			            if (!el) {
			                return;
			            }

			            var customEvent = new CustomEvent(event, {
			                detail: detail
			            });
			            el.dispatchEvent(customEvent);
			        },

			        Listener: {
			            uid: 0
			        },
			        on: function on(el, events, fn) {
			            var _this = this;

			            if (!el) {
			                return;
			            }

			            events.split(' ').forEach(function (event) {
			                var _id = _this.getAttribute(el, 'lg-event-uid') || '';
			                utils.Listener.uid++;
			                _id += '&' + utils.Listener.uid;
			                _this.setAttribute(el, 'lg-event-uid', _id);
			                utils.Listener[event + utils.Listener.uid] = fn;
			                el.addEventListener(event.split('.')[0], fn, false);
			            });
			        },

			        off: function off(el, event) {
			            if (!el) {
			                return;
			            }

			            var _id = this.getAttribute(el, 'lg-event-uid');
			            if (_id) {
			                _id = _id.split('&');
			                for (var i = 0; i < _id.length; i++) {
			                    if (_id[i]) {
			                        var _event = event + _id[i];
			                        if (_event.substring(0, 1) === '.') {
			                            for (var key in utils.Listener) {
			                                if (utils.Listener.hasOwnProperty(key)) {
			                                    if (key.split('.').indexOf(_event.split('.')[1]) > -1) {
			                                        el.removeEventListener(key.split('.')[0], utils.Listener[key]);
			                                        this.setAttribute(el, 'lg-event-uid', this.getAttribute(el, 'lg-event-uid').replace('&' + _id[i], ''));
			                                        delete utils.Listener[key];
			                                    }
			                                }
			                            }
			                        } else {
			                            el.removeEventListener(_event.split('.')[0], utils.Listener[_event]);
			                            this.setAttribute(el, 'lg-event-uid', this.getAttribute(el, 'lg-event-uid').replace('&' + _id[i], ''));
			                            delete utils.Listener[_event];
			                        }
			                    }
			                }
			            }
			        },

			        param: function param(obj) {
			            return Object.keys(obj).map(function (k) {
			                return encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]);
			            }).join('&');
			        }
			    };

			    exports.default = utils;
			});
	} (lgUtils));
		return lgUtils;
	}

	(function (exports) {
		(function (global, factory) {
		    {
		        factory(requireLgUtils());
		    }
		})(commonjsGlobal, function (_lgUtils) {

		    var _lgUtils2 = _interopRequireDefault(_lgUtils);

		    function _interopRequireDefault(obj) {
		        return obj && obj.__esModule ? obj : {
		            default: obj
		        };
		    }

		    var _extends = Object.assign || function (target) {
		        for (var i = 1; i < arguments.length; i++) {
		            var source = arguments[i];

		            for (var key in source) {
		                if (Object.prototype.hasOwnProperty.call(source, key)) {
		                    target[key] = source[key];
		                }
		            }
		        }

		        return target;
		    };

		    /** Polyfill the CustomEvent() constructor functionality in Internet Explorer 9 and higher */
		    (function () {

		        if (typeof window.CustomEvent === 'function') {
		            return false;
		        }

		        function CustomEvent(event, params) {
		            params = params || {
		                bubbles: false,
		                cancelable: false,
		                detail: undefined
		            };
		            var evt = document.createEvent('CustomEvent');
		            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		            return evt;
		        }

		        CustomEvent.prototype = window.Event.prototype;

		        window.CustomEvent = CustomEvent;
		    })();

		    window.utils = _lgUtils2.default;
		    window.lgData = {
		        uid: 0
		    };

		    window.lgModules = {};
		    var defaults = {

		        mode: 'lg-slide',

		        // Ex : 'ease'
		        cssEasing: 'ease',

		        //'for jquery animation'
		        easing: 'linear',
		        speed: 600,
		        height: '100%',
		        width: '100%',
		        addClass: '',
		        startClass: 'lg-start-zoom',
		        backdropDuration: 150,

		        // Set 0, if u don't want to hide the controls 
		        hideBarsDelay: 6000,

		        useLeft: false,

		        // aria-labelledby attribute fot gallery
		        ariaLabelledby: '',

		        //aria-describedby attribute for gallery
		        ariaDescribedby: '',

		        closable: true,
		        loop: true,
		        escKey: true,
		        keyPress: true,
		        controls: true,
		        slideEndAnimatoin: true,
		        hideControlOnEnd: false,
		        mousewheel: false,

		        getCaptionFromTitleOrAlt: true,

		        // .lg-item || '.lg-sub-html'
		        appendSubHtmlTo: '.lg-sub-html',

		        subHtmlSelectorRelative: false,

		        /**
		         * @desc number of preload slides
		         * will exicute only after the current slide is fully loaded.
		         *
		         * @ex you clicked on 4th image and if preload = 1 then 3rd slide and 5th
		         * slide will be loaded in the background after the 4th slide is fully loaded..
		         * if preload is 2 then 2nd 3rd 5th 6th slides will be preloaded.. ... ...
		         *
		         */
		        preload: 1,
		        showAfterLoad: true,
		        selector: '',
		        selectWithin: '',
		        nextHtml: '',
		        prevHtml: '',

		        // 0, 1
		        index: false,

		        iframeMaxWidth: '100%',

		        download: true,
		        counter: true,
		        appendCounterTo: '.lg-toolbar',

		        swipeThreshold: 50,
		        enableSwipe: true,
		        enableDrag: true,

		        dynamic: false,
		        dynamicEl: [],
		        galleryId: 1,
		        supportLegacyBrowser: true
		    };

		    function Plugin(element, options) {

		        // Current lightGallery element
		        this.el = element;

		        // lightGallery settings
		        this.s = _extends({}, defaults, options);

		        // When using dynamic mode, ensure dynamicEl is an array
		        if (this.s.dynamic && this.s.dynamicEl !== 'undefined' && this.s.dynamicEl.constructor === Array && !this.s.dynamicEl.length) {
		            throw 'When using dynamic mode, you must also define dynamicEl as an Array.';
		        }

		        // lightGallery modules
		        this.modules = {};

		        // false when lightgallery complete first slide;
		        this.lGalleryOn = false;

		        this.lgBusy = false;

		        // Timeout function for hiding controls;
		        this.hideBartimeout = false;

		        // To determine browser supports for touch events;
		        this.isTouch = 'ontouchstart' in document.documentElement;

		        // Disable hideControlOnEnd if sildeEndAnimation is true
		        if (this.s.slideEndAnimatoin) {
		            this.s.hideControlOnEnd = false;
		        }

		        this.items = [];

		        // Gallery items
		        if (this.s.dynamic) {
		            this.items = this.s.dynamicEl;
		        } else {
		            if (this.s.selector === 'this') {
		                this.items.push(this.el);
		            } else if (this.s.selector !== '') {
		                if (this.s.selectWithin) {
		                    this.items = document.querySelector(this.s.selectWithin).querySelectorAll(this.s.selector);
		                } else {
		                    this.items = this.el.querySelectorAll(this.s.selector);
		                }
		            } else {
		                this.items = this.el.children;
		            }
		        }

		        // .lg-item

		        this.___slide = '';

		        // .lg-outer
		        this.outer = '';

		        this.init();

		        return this;
		    }

		    Plugin.prototype.init = function () {

		        var _this = this;

		        // s.preload should not be more than $item.length
		        if (_this.s.preload > _this.items.length) {
		            _this.s.preload = _this.items.length;
		        }

		        // if dynamic option is enabled execute immediately
		        var _hash = window.location.hash;
		        if (_hash.indexOf('lg=' + this.s.galleryId) > 0) {

		            _this.index = parseInt(_hash.split('&slide=')[1], 10);

		            _lgUtils2.default.addClass(document.body, 'lg-from-hash');
		            if (!_lgUtils2.default.hasClass(document.body, 'lg-on')) {
		                _lgUtils2.default.addClass(document.body, 'lg-on');
		                setTimeout(function () {
		                    _this.build(_this.index);
		                });
		            }
		        }

		        if (_this.s.dynamic) {

		            _lgUtils2.default.trigger(this.el, 'onBeforeOpen');

		            _this.index = _this.s.index || 0;

		            // prevent accidental double execution
		            if (!_lgUtils2.default.hasClass(document.body, 'lg-on')) {
		                _lgUtils2.default.addClass(document.body, 'lg-on');
		                setTimeout(function () {
		                    _this.build(_this.index);
		                });
		            }
		        } else {

		            for (var i = 0; i < _this.items.length; i++) {

		                /*jshint loopfunc: true */
		                (function (index) {

		                    // Using different namespace for click because click event should not unbind if selector is same object('this')
		                    _lgUtils2.default.on(_this.items[index], 'click.lgcustom', function (e) {

		                        e.preventDefault();

		                        _lgUtils2.default.trigger(_this.el, 'onBeforeOpen');

		                        _this.index = _this.s.index || index;

		                        if (!_lgUtils2.default.hasClass(document.body, 'lg-on')) {
		                            _this.build(_this.index);
		                            _lgUtils2.default.addClass(document.body, 'lg-on');
		                        }
		                    });
		                })(i);
		            }
		        }
		    };

		    Plugin.prototype.build = function (index) {

		        var _this = this;

		        _this.structure();

		        for (var key in window.lgModules) {
		            _this.modules[key] = new window.lgModules[key](_this.el);
		        }

		        // initiate slide function
		        _this.slide(index, false, false);

		        if (_this.s.keyPress) {
		            _this.keyPress();
		        }

		        if (_this.items.length > 1) {

		            _this.arrow();

		            setTimeout(function () {
		                _this.enableDrag();
		                _this.enableSwipe();
		            }, 50);

		            if (_this.s.mousewheel) {
		                _this.mousewheel();
		            }
		        }

		        _this.counter();

		        _this.closeGallery();

		        _lgUtils2.default.trigger(_this.el, 'onAfterOpen');

		        // Hide controllers if mouse doesn't move for some period
		        if (_this.s.hideBarsDelay > 0) {

		            // Hide controls if user doesn't use mouse or touch after opening gallery
		            var initialHideBarTimeout = setTimeout(function () {
		                _lgUtils2.default.addClass(_this.outer, 'lg-hide-items');
		            }, _this.s.hideBarsDelay);
		            _lgUtils2.default.on(_this.outer, 'mousemove.lg click.lg touchstart.lg', function () {

		                // Cancel initalHideBarTimout if user uses mouse or touch events
		                // Before it fires
		                clearTimeout(initialHideBarTimeout);

		                _lgUtils2.default.removeClass(_this.outer, 'lg-hide-items');

		                clearTimeout(_this.hideBartimeout);

		                // Timeout will be cleared on each slide movement also
		                _this.hideBartimeout = setTimeout(function () {
		                    _lgUtils2.default.addClass(_this.outer, 'lg-hide-items');
		                }, _this.s.hideBarsDelay);
		            });
		        }
		    };

		    Plugin.prototype.structure = function () {
		        var list = '';
		        var controls = '';
		        var i = 0;
		        var subHtmlCont = '';
		        var template;
		        var _this = this;

		        document.body.insertAdjacentHTML('beforeend', '<div class="lg-backdrop"></div>');
		        _lgUtils2.default.setVendor(document.querySelector('.lg-backdrop'), 'TransitionDuration', this.s.backdropDuration + 'ms');

		        // Create gallery items
		        for (i = 0; i < this.items.length; i++) {
		            list += '<div class="lg-item"></div>';
		        }

		        // Create controlls
		        if (this.s.controls && this.items.length > 1) {
		            controls = '<div class="lg-actions">' + '<button type="button" aria-label="Previous slide" class="lg-prev lg-icon">' + this.s.prevHtml + '</button>' + '<button type="button" aria-label="Next slide" class="lg-next lg-icon">' + this.s.nextHtml + '</button>' + '</div>';
		        }

		        if (this.s.appendSubHtmlTo === '.lg-sub-html') {
		            subHtmlCont = '<div role="status" aria-live="polite" class="lg-sub-html"></div>';
		        }

		        var ariaLabelledby = this.s.ariaLabelledby ? 'aria-labelledby="' + this.s.ariaLabelledby + '"' : '';
		        var ariaDescribedby = this.s.ariaDescribedby ? 'aria-describedby="' + this.s.ariaDescribedby + '"' : '';

		        template = '<div tabindex="-1" aria-modal="true" ' + ariaLabelledby + ' ' + ariaDescribedby + ' role="dialog" class="lg-outer ' + this.s.addClass + ' ' + this.s.startClass + '">' + '<div class="lg" style="width:' + this.s.width + '; height:' + this.s.height + '">' + '<div class="lg-inner">' + list + '</div>' + '<div class="lg-toolbar lg-group">' + '<button type="button" aria-label="Close gallery" class="lg-close lg-icon"></button>' + '</div>' + controls + subHtmlCont + '</div>' + '</div>';

		        document.body.insertAdjacentHTML('beforeend', template);
		        this.outer = document.querySelector('.lg-outer');
		        this.outer.focus();
		        this.___slide = this.outer.querySelectorAll('.lg-item');

		        if (this.s.useLeft) {
		            _lgUtils2.default.addClass(this.outer, 'lg-use-left');

		            // Set mode lg-slide if use left is true;
		            this.s.mode = 'lg-slide';
		        } else {
		            _lgUtils2.default.addClass(this.outer, 'lg-use-css3');
		        }

		        // For fixed height gallery
		        _this.setTop();
		        _lgUtils2.default.on(window, 'resize.lg orientationchange.lg', function () {
		            setTimeout(function () {
		                _this.setTop();
		            }, 100);
		        });

		        // add class lg-current to remove initial transition
		        _lgUtils2.default.addClass(this.___slide[this.index], 'lg-current');

		        // add Class for css support and transition mode
		        if (this.doCss()) {
		            _lgUtils2.default.addClass(this.outer, 'lg-css3');
		        } else {
		            _lgUtils2.default.addClass(this.outer, 'lg-css');

		            // Set speed 0 because no animation will happen if browser doesn't support css3
		            this.s.speed = 0;
		        }

		        _lgUtils2.default.addClass(this.outer, this.s.mode);

		        if (this.s.enableDrag && this.items.length > 1) {
		            _lgUtils2.default.addClass(this.outer, 'lg-grab');
		        }

		        if (this.s.showAfterLoad) {
		            _lgUtils2.default.addClass(this.outer, 'lg-show-after-load');
		        }

		        if (this.doCss()) {
		            var inner = this.outer.querySelector('.lg-inner');
		            _lgUtils2.default.setVendor(inner, 'TransitionTimingFunction', this.s.cssEasing);
		            _lgUtils2.default.setVendor(inner, 'TransitionDuration', this.s.speed + 'ms');
		        }

		        setTimeout(function () {
		            _lgUtils2.default.addClass(document.querySelector('.lg-backdrop'), 'in');
		        });

		        setTimeout(function () {
		            _lgUtils2.default.addClass(_this.outer, 'lg-visible');
		        }, this.s.backdropDuration);

		        if (this.s.download) {
		            this.outer.querySelector('.lg-toolbar').insertAdjacentHTML('beforeend', '<a id="lg-download" aria-label="Download" target="_blank" download class="lg-download lg-icon"></a>');
		        }

		        // Store the current scroll top value to scroll back after closing the gallery..
		        this.prevScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		    };

		    // For fixed height gallery
		    Plugin.prototype.setTop = function () {
		        if (this.s.height !== '100%') {
		            var wH = window.innerHeight;
		            var top = (wH - parseInt(this.s.height, 10)) / 2;
		            var lGallery = this.outer.querySelector('.lg');
		            if (wH >= parseInt(this.s.height, 10)) {
		                lGallery.style.top = top + 'px';
		            } else {
		                lGallery.style.top = '0px';
		            }
		        }
		    };

		    // Find css3 support
		    Plugin.prototype.doCss = function () {
		        // check for css animation support
		        var support = function support() {
		            var transition = ['transition', 'MozTransition', 'WebkitTransition', 'OTransition', 'msTransition', 'KhtmlTransition'];
		            var root = document.documentElement;
		            var i = 0;
		            for (i = 0; i < transition.length; i++) {
		                if (transition[i] in root.style) {
		                    return true;
		                }
		            }
		        };

		        if (support()) {
		            return true;
		        }

		        return false;
		    };

		    /**
		     *  @desc Check the given src is video
		     *  @param {String} src
		     *  @return {Object} video type
		     *  Ex:{ youtube  :  ["//www.youtube.com/watch?v=c0asJgSyxcY", "c0asJgSyxcY"] }
		     */
		    Plugin.prototype.isVideo = function (src, index) {

		        var html;
		        if (this.s.dynamic) {
		            html = this.s.dynamicEl[index].html;
		        } else {
		            html = this.items[index].getAttribute('data-html');
		        }

		        if (!src && html) {
		            return {
		                html5: true
		            };
		        }

		        var youtube = src.match(/\/\/(?:www\.)?youtu(?:\.be|be\.com|be-nocookie\.com)\/(?:watch\?v=|embed\/)?([a-z0-9\-\_\%]+)/i);
		        var vimeo = src.match(/\/\/(?:www\.)?vimeo.com\/([0-9a-z\-_]+)/i);
		        var dailymotion = src.match(/\/\/(?:www\.)?dai.ly\/([0-9a-z\-_]+)/i);
		        var vk = src.match(/\/\/(?:www\.)?(?:vk\.com|vkontakte\.ru)\/(?:video_ext\.php\?)(.*)/i);

		        if (youtube) {
		            return {
		                youtube: youtube
		            };
		        } else if (vimeo) {
		            return {
		                vimeo: vimeo
		            };
		        } else if (dailymotion) {
		            return {
		                dailymotion: dailymotion
		            };
		        } else if (vk) {
		            return {
		                vk: vk
		            };
		        }
		    };

		    /**
		     *  @desc Create image counter
		     *  Ex: 1/10
		     */
		    Plugin.prototype.counter = function () {
		        if (this.s.counter) {
		            this.outer.querySelector(this.s.appendCounterTo).insertAdjacentHTML('beforeend', '<div id="lg-counter" role="status" aria-live="polite"><span id="lg-counter-current">' + (parseInt(this.index, 10) + 1) + '</span> / <span id="lg-counter-all">' + this.items.length + '</span></div>');
		        }
		    };

		    /**
		     *  @desc add sub-html into the slide
		     *  @param {Number} index - index of the slide
		     */
		    Plugin.prototype.addHtml = function (index) {
		        var subHtml = null;
		        var currentEle;
		        if (this.s.dynamic) {
		            subHtml = this.s.dynamicEl[index].subHtml;
		        } else {
		            currentEle = this.items[index];
		            subHtml = currentEle.getAttribute('data-sub-html');
		            if (this.s.getCaptionFromTitleOrAlt && !subHtml) {
		                subHtml = currentEle.getAttribute('title');
		                if (subHtml && currentEle.querySelector('img')) {
		                    subHtml = currentEle.querySelector('img').getAttribute('alt');
		                }
		            }
		        }

		        if (typeof subHtml !== 'undefined' && subHtml !== null) {

		            // get first letter of subhtml
		            // if first letter starts with . or # get the html form the jQuery object
		            var fL = subHtml.substring(0, 1);
		            if (fL === '.' || fL === '#') {
		                if (this.s.subHtmlSelectorRelative && !this.s.dynamic) {
		                    subHtml = currentEle.querySelector(subHtml).innerHTML;
		                } else {
		                    subHtml = document.querySelector(subHtml).innerHTML;
		                }
		            }
		        } else {
		            subHtml = '';
		        }

		        if (this.s.appendSubHtmlTo === '.lg-sub-html') {
		            this.outer.querySelector(this.s.appendSubHtmlTo).innerHTML = subHtml;
		        } else {
		            this.___slide[index].insertAdjacentHTML('beforeend', subHtml);
		        }

		        // Add lg-empty-html class if title doesn't exist
		        if (typeof subHtml !== 'undefined' && subHtml !== null) {
		            if (subHtml === '') {
		                _lgUtils2.default.addClass(this.outer.querySelector(this.s.appendSubHtmlTo), 'lg-empty-html');
		            } else {
		                _lgUtils2.default.removeClass(this.outer.querySelector(this.s.appendSubHtmlTo), 'lg-empty-html');
		            }
		        }

		        _lgUtils2.default.trigger(this.el, 'onAfterAppendSubHtml', {
		            index: index
		        });
		    };

		    /**
		     *  @desc Preload slides
		     *  @param {Number} index - index of the slide
		     */
		    Plugin.prototype.preload = function (index) {
		        var i = 1;
		        var j = 1;
		        for (i = 1; i <= this.s.preload; i++) {
		            if (i >= this.items.length - index) {
		                break;
		            }

		            this.loadContent(index + i, false, 0);
		        }

		        for (j = 1; j <= this.s.preload; j++) {
		            if (index - j < 0) {
		                break;
		            }

		            this.loadContent(index - j, false, 0);
		        }
		    };

		    /**
		     *  @desc Load slide content into slide.
		     *  @param {Number} index - index of the slide.
		     *  @param {Boolean} rec - if true call loadcontent() function again.
		     *  @param {Boolean} delay - delay for adding complete class. it is 0 except first time.
		     */
		    Plugin.prototype.loadContent = function (index, rec, delay) {

		        var _this = this;
		        var _hasPoster = false;
		        var _img;
		        var _src;
		        var _poster;
		        var _srcset;
		        var _sizes;
		        var _html;
		        var _alt;
		        var getResponsiveSrc = function getResponsiveSrc(srcItms) {
		            var rsWidth = [];
		            var rsSrc = [];
		            for (var i = 0; i < srcItms.length; i++) {
		                var __src = srcItms[i].split(' ');

		                // Manage empty space
		                if (__src[0] === '') {
		                    __src.splice(0, 1);
		                }

		                rsSrc.push(__src[0]);
		                rsWidth.push(__src[1]);
		            }

		            var wWidth = window.innerWidth;
		            for (var j = 0; j < rsWidth.length; j++) {
		                if (parseInt(rsWidth[j], 10) > wWidth) {
		                    _src = rsSrc[j];
		                    break;
		                }
		            }
		        };

		        if (_this.s.dynamic) {

		            if (_this.s.dynamicEl[index].poster) {
		                _hasPoster = true;
		                _poster = _this.s.dynamicEl[index].poster;
		            }

		            _html = _this.s.dynamicEl[index].html;
		            _src = _this.s.dynamicEl[index].src;
		            _alt = _this.s.dynamicEl[index].alt;

		            if (_this.s.dynamicEl[index].responsive) {
		                var srcDyItms = _this.s.dynamicEl[index].responsive.split(',');
		                getResponsiveSrc(srcDyItms);
		            }

		            _srcset = _this.s.dynamicEl[index].srcset;
		            _sizes = _this.s.dynamicEl[index].sizes;
		        } else {

		            if (_this.items[index].getAttribute('data-poster')) {
		                _hasPoster = true;
		                _poster = _this.items[index].getAttribute('data-poster');
		            }

		            _html = _this.items[index].getAttribute('data-html');
		            _src = _this.items[index].getAttribute('href') || _this.items[index].getAttribute('data-src');
		            _alt = _this.items[index].getAttribute('title');

		            if (_this.items[index].querySelector('img')) {
		                _alt = _alt || _this.items[index].querySelector('img').getAttribute('alt');
		            }

		            if (_this.items[index].getAttribute('data-responsive')) {
		                var srcItms = _this.items[index].getAttribute('data-responsive').split(',');
		                getResponsiveSrc(srcItms);
		            }

		            _srcset = _this.items[index].getAttribute('data-srcset');
		            _sizes = _this.items[index].getAttribute('data-sizes');
		        }

		        //if (_src || _srcset || _sizes || _poster) {

		        var iframe = false;
		        if (_this.s.dynamic) {
		            if (_this.s.dynamicEl[index].iframe) {
		                iframe = true;
		            }
		        } else {
		            if (_this.items[index].getAttribute('data-iframe') === 'true') {
		                iframe = true;
		            }
		        }

		        var _isVideo = _this.isVideo(_src, index);
		        if (!_lgUtils2.default.hasClass(_this.___slide[index], 'lg-loaded')) {
		            if (iframe) {
		                _this.___slide[index].insertAdjacentHTML('afterbegin', '<div class="lg-video-cont" style="max-width:' + _this.s.iframeMaxWidth + '"><div class="lg-video"><iframe class="lg-object" frameborder="0" src="' + _src + '"  allowfullscreen="true"></iframe></div></div>');
		            } else if (_hasPoster) {
		                var videoClass = '';
		                if (_isVideo && _isVideo.youtube) {
		                    videoClass = 'lg-has-youtube';
		                } else if (_isVideo && _isVideo.vimeo) {
		                    videoClass = 'lg-has-vimeo';
		                } else {
		                    videoClass = 'lg-has-html5';
		                }

		                _this.___slide[index].insertAdjacentHTML('beforeend', '<div class="lg-video-cont ' + videoClass + ' "><div class="lg-video"><span class="lg-video-play"></span><img class="lg-object lg-has-poster" src="' + _poster + '" /></div></div>');
		            } else if (_isVideo) {
		                _this.___slide[index].insertAdjacentHTML('beforeend', '<div class="lg-video-cont "><div class="lg-video"></div></div>');
		                _lgUtils2.default.trigger(_this.el, 'hasVideo', {
		                    index: index,
		                    src: _src,
		                    html: _html
		                });
		            } else {
		                _alt = _alt ? 'alt="' + _alt + '"' : '';
		                _this.___slide[index].insertAdjacentHTML('beforeend', '<div class="lg-img-wrap"><img class="lg-object lg-image" ' + _alt + ' src="' + _src + '" /></div>');
		            }

		            _lgUtils2.default.trigger(_this.el, 'onAferAppendSlide', {
		                index: index
		            });

		            _img = _this.___slide[index].querySelector('.lg-object');
		            if (_sizes) {
		                _img.setAttribute('sizes', _sizes);
		            }

		            if (_srcset) {
		                _img.setAttribute('srcset', _srcset);

		                if (this.s.supportLegacyBrowser) {
		                    try {
		                        picturefill({
		                            elements: [_img[0]]
		                        });
		                    } catch (e) {
		                        console.warn('If you want srcset to be supported for older browsers, ' + 'please include picturefil javascript library in your document.');
		                    }
		                }
		            }

		            if (this.s.appendSubHtmlTo !== '.lg-sub-html') {
		                _this.addHtml(index);
		            }

		            _lgUtils2.default.addClass(_this.___slide[index], 'lg-loaded');
		        }

		        _lgUtils2.default.on(_this.___slide[index].querySelector('.lg-object'), 'load.lg error.lg', function () {

		            // For first time add some delay for displaying the start animation.
		            var _speed = 0;

		            // Do not change the delay value because it is required for zoom plugin.
		            // If gallery opened from direct url (hash) speed value should be 0
		            if (delay && !_lgUtils2.default.hasClass(document.body, 'lg-from-hash')) {
		                _speed = delay;
		            }

		            setTimeout(function () {
		                _lgUtils2.default.addClass(_this.___slide[index], 'lg-complete');

		                _lgUtils2.default.trigger(_this.el, 'onSlideItemLoad', {
		                    index: index,
		                    delay: delay || 0
		                });
		            }, _speed);
		        });

		        // @todo check load state for html5 videos
		        if (_isVideo && _isVideo.html5 && !_hasPoster) {
		            _lgUtils2.default.addClass(_this.___slide[index], 'lg-complete');
		        }

		        if (rec === true) {
		            if (!_lgUtils2.default.hasClass(_this.___slide[index], 'lg-complete')) {
		                _lgUtils2.default.on(_this.___slide[index].querySelector('.lg-object'), 'load.lg error.lg', function () {
		                    _this.preload(index);
		                });
		            } else {
		                _this.preload(index);
		            }
		        }

		        //}
		    };

		    /**
		    *   @desc slide function for lightgallery
		        ** Slide() gets call on start
		        ** ** Set lg.on true once slide() function gets called.
		        ** Call loadContent() on slide() function inside setTimeout
		        ** ** On first slide we do not want any animation like slide of fade
		        ** ** So on first slide( if lg.on if false that is first slide) loadContent() should start loading immediately
		        ** ** Else loadContent() should wait for the transition to complete.
		        ** ** So set timeout s.speed + 50
		    <=> ** loadContent() will load slide content in to the particular slide
		        ** ** It has recursion (rec) parameter. if rec === true loadContent() will call preload() function.
		        ** ** preload will execute only when the previous slide is fully loaded (images iframe)
		        ** ** avoid simultaneous image load
		    <=> ** Preload() will check for s.preload value and call loadContent() again accoring to preload value
		        ** loadContent()  <====> Preload();
		    
		    *   @param {Number} index - index of the slide
		    *   @param {Boolean} fromTouch - true if slide function called via touch event or mouse drag
		    *   @param {Boolean} fromThumb - true if slide function called via thumbnail click
		    */
		    Plugin.prototype.slide = function (index, fromTouch, fromThumb) {

		        var _prevIndex = 0;
		        for (var i = 0; i < this.___slide.length; i++) {
		            if (_lgUtils2.default.hasClass(this.___slide[i], 'lg-current')) {
		                _prevIndex = i;
		                break;
		            }
		        }

		        var _this = this;

		        // Prevent if multiple call
		        // Required for hsh plugin
		        if (_this.lGalleryOn && _prevIndex === index) {
		            return;
		        }

		        var _length = this.___slide.length;
		        var _time = _this.lGalleryOn ? this.s.speed : 0;
		        var _next = false;
		        var _prev = false;

		        if (!_this.lgBusy) {

		            if (this.s.download) {
		                var _src;
		                if (_this.s.dynamic) {
		                    _src = _this.s.dynamicEl[index].downloadUrl !== false && (_this.s.dynamicEl[index].downloadUrl || _this.s.dynamicEl[index].src);
		                } else {
		                    _src = _this.items[index].getAttribute('data-download-url') !== 'false' && (_this.items[index].getAttribute('data-download-url') || _this.items[index].getAttribute('href') || _this.items[index].getAttribute('data-src'));
		                }

		                if (_src) {
		                    document.getElementById('lg-download').setAttribute('href', _src);
		                    _lgUtils2.default.removeClass(_this.outer, 'lg-hide-download');
		                } else {
		                    _lgUtils2.default.addClass(_this.outer, 'lg-hide-download');
		                }
		            }

		            _lgUtils2.default.trigger(_this.el, 'onBeforeSlide', {
		                prevIndex: _prevIndex,
		                index: index,
		                fromTouch: fromTouch,
		                fromThumb: fromThumb
		            });

		            _this.lgBusy = true;

		            clearTimeout(_this.hideBartimeout);

		            // Add title if this.s.appendSubHtmlTo === lg-sub-html
		            if (this.s.appendSubHtmlTo === '.lg-sub-html') {

		                // wait for slide animation to complete
		                setTimeout(function () {
		                    _this.addHtml(index);
		                }, _time);
		            }

		            this.arrowDisable(index);

		            if (!fromTouch) {

		                // remove all transitions
		                _lgUtils2.default.addClass(_this.outer, 'lg-no-trans');

		                for (var j = 0; j < this.___slide.length; j++) {
		                    _lgUtils2.default.removeClass(this.___slide[j], 'lg-prev-slide');
		                    _lgUtils2.default.removeClass(this.___slide[j], 'lg-next-slide');
		                }

		                if (index < _prevIndex) {
		                    _prev = true;
		                    if (index === 0 && _prevIndex === _length - 1 && !fromThumb) {
		                        _prev = false;
		                        _next = true;
		                    }
		                } else if (index > _prevIndex) {
		                    _next = true;
		                    if (index === _length - 1 && _prevIndex === 0 && !fromThumb) {
		                        _prev = true;
		                        _next = false;
		                    }
		                }

		                if (_prev) {

		                    //prevslide
		                    _lgUtils2.default.addClass(this.___slide[index], 'lg-prev-slide');
		                    _lgUtils2.default.addClass(this.___slide[_prevIndex], 'lg-next-slide');
		                } else if (_next) {

		                    // next slide
		                    _lgUtils2.default.addClass(this.___slide[index], 'lg-next-slide');
		                    _lgUtils2.default.addClass(this.___slide[_prevIndex], 'lg-prev-slide');
		                }

		                // give 50 ms for browser to add/remove class
		                setTimeout(function () {
		                    _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-current'), 'lg-current');

		                    //_this.$slide.eq(_prevIndex).removeClass('lg-current');
		                    _lgUtils2.default.addClass(_this.___slide[index], 'lg-current');

		                    // reset all transitions
		                    _lgUtils2.default.removeClass(_this.outer, 'lg-no-trans');
		                }, 50);
		            } else {

		                var touchPrev = index - 1;
		                var touchNext = index + 1;

		                if (index === 0 && _prevIndex === _length - 1) {

		                    // next slide
		                    touchNext = 0;
		                    touchPrev = _length - 1;
		                } else if (index === _length - 1 && _prevIndex === 0) {

		                    // prev slide
		                    touchNext = 0;
		                    touchPrev = _length - 1;
		                }

		                _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-prev-slide'), 'lg-prev-slide');
		                _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-current'), 'lg-current');
		                _lgUtils2.default.removeClass(_this.outer.querySelector('.lg-next-slide'), 'lg-next-slide');
		                _lgUtils2.default.addClass(_this.___slide[touchPrev], 'lg-prev-slide');
		                _lgUtils2.default.addClass(_this.___slide[touchNext], 'lg-next-slide');
		                _lgUtils2.default.addClass(_this.___slide[index], 'lg-current');
		            }

		            if (_this.lGalleryOn) {
		                setTimeout(function () {
		                    _this.loadContent(index, true, 0);
		                }, this.s.speed + 50);

		                setTimeout(function () {
		                    _this.lgBusy = false;
		                    _lgUtils2.default.trigger(_this.el, 'onAfterSlide', {
		                        prevIndex: _prevIndex,
		                        index: index,
		                        fromTouch: fromTouch,
		                        fromThumb: fromThumb
		                    });
		                }, this.s.speed);
		            } else {
		                _this.loadContent(index, true, _this.s.backdropDuration);

		                _this.lgBusy = false;
		                _lgUtils2.default.trigger(_this.el, 'onAfterSlide', {
		                    prevIndex: _prevIndex,
		                    index: index,
		                    fromTouch: fromTouch,
		                    fromThumb: fromThumb
		                });
		            }

		            _this.lGalleryOn = true;

		            if (this.s.counter) {
		                if (document.getElementById('lg-counter-current')) {
		                    document.getElementById('lg-counter-current').innerHTML = index + 1;
		                }
		            }
		        }
		    };

		    /**
		     *  @desc Go to next slide
		     *  @param {Boolean} fromTouch - true if slide function called via touch event
		     */
		    Plugin.prototype.goToNextSlide = function (fromTouch) {
		        var _this = this;
		        if (!_this.lgBusy) {
		            if (_this.index + 1 < _this.___slide.length) {
		                _this.index++;
		                _lgUtils2.default.trigger(_this.el, 'onBeforeNextSlide', {
		                    index: _this.index
		                });
		                _this.slide(_this.index, fromTouch, false);
		            } else {
		                if (_this.s.loop) {
		                    _this.index = 0;
		                    _lgUtils2.default.trigger(_this.el, 'onBeforeNextSlide', {
		                        index: _this.index
		                    });
		                    _this.slide(_this.index, fromTouch, false);
		                } else if (_this.s.slideEndAnimatoin) {
		                    _lgUtils2.default.addClass(_this.outer, 'lg-right-end');
		                    setTimeout(function () {
		                        _lgUtils2.default.removeClass(_this.outer, 'lg-right-end');
		                    }, 400);
		                }
		            }
		        }
		    };

		    /**
		     *  @desc Go to previous slide
		     *  @param {Boolean} fromTouch - true if slide function called via touch event
		     */
		    Plugin.prototype.goToPrevSlide = function (fromTouch) {
		        var _this = this;
		        if (!_this.lgBusy) {
		            if (_this.index > 0) {
		                _this.index--;
		                _lgUtils2.default.trigger(_this.el, 'onBeforePrevSlide', {
		                    index: _this.index,
		                    fromTouch: fromTouch
		                });
		                _this.slide(_this.index, fromTouch, false);
		            } else {
		                if (_this.s.loop) {
		                    _this.index = _this.items.length - 1;
		                    _lgUtils2.default.trigger(_this.el, 'onBeforePrevSlide', {
		                        index: _this.index,
		                        fromTouch: fromTouch
		                    });
		                    _this.slide(_this.index, fromTouch, false);
		                } else if (_this.s.slideEndAnimatoin) {
		                    _lgUtils2.default.addClass(_this.outer, 'lg-left-end');
		                    setTimeout(function () {
		                        _lgUtils2.default.removeClass(_this.outer, 'lg-left-end');
		                    }, 400);
		                }
		            }
		        }
		    };

		    Plugin.prototype.keyPress = function () {
		        var _this = this;
		        if (this.items.length > 1) {
		            _lgUtils2.default.on(window, 'keyup.lg', function (e) {
		                if (_this.items.length > 1) {
		                    if (e.keyCode === 37) {
		                        e.preventDefault();
		                        _this.goToPrevSlide();
		                    }

		                    if (e.keyCode === 39) {
		                        e.preventDefault();
		                        _this.goToNextSlide();
		                    }
		                }
		            });
		        }

		        _lgUtils2.default.on(window, 'keydown.lg', function (e) {
		            if (_this.s.escKey === true && e.keyCode === 27) {
		                e.preventDefault();
		                if (!_lgUtils2.default.hasClass(_this.outer, 'lg-thumb-open')) {
		                    _this.destroy();
		                } else {
		                    _lgUtils2.default.removeClass(_this.outer, 'lg-thumb-open');
		                }
		            }
		        });
		    };

		    Plugin.prototype.arrow = function () {
		        var _this = this;
		        _lgUtils2.default.on(this.outer.querySelector('.lg-prev'), 'click.lg', function () {
		            _this.goToPrevSlide();
		        });

		        _lgUtils2.default.on(this.outer.querySelector('.lg-next'), 'click.lg', function () {
		            _this.goToNextSlide();
		        });
		    };

		    Plugin.prototype.arrowDisable = function (index) {

		        // Disable arrows if s.hideControlOnEnd is true
		        if (!this.s.loop && this.s.hideControlOnEnd) {
		            var next = this.outer.querySelector('.lg-next');
		            var prev = this.outer.querySelector('.lg-prev');
		            if (index + 1 < this.___slide.length) {
		                next.removeAttribute('disabled');
		                _lgUtils2.default.removeClass(next, 'disabled');
		            } else {
		                next.setAttribute('disabled', 'disabled');
		                _lgUtils2.default.addClass(next, 'disabled');
		            }

		            if (index > 0) {
		                prev.removeAttribute('disabled');
		                _lgUtils2.default.removeClass(prev, 'disabled');
		            } else {
		                prev.setAttribute('disabled', 'disabled');
		                _lgUtils2.default.addClass(prev, 'disabled');
		            }
		        }
		    };

		    Plugin.prototype.setTranslate = function (el, xValue, yValue) {
		        // jQuery supports Automatic CSS prefixing since jQuery 1.8.0
		        if (this.s.useLeft) {
		            el.style.left = xValue;
		        } else {
		            _lgUtils2.default.setVendor(el, 'Transform', 'translate3d(' + xValue + 'px, ' + yValue + 'px, 0px)');
		        }
		    };

		    Plugin.prototype.touchMove = function (startCoords, endCoords) {

		        var distance = endCoords - startCoords;

		        if (Math.abs(distance) > 15) {
		            // reset opacity and transition duration
		            _lgUtils2.default.addClass(this.outer, 'lg-dragging');

		            // move current slide
		            this.setTranslate(this.___slide[this.index], distance, 0);

		            // move next and prev slide with current slide
		            this.setTranslate(document.querySelector('.lg-prev-slide'), -this.___slide[this.index].clientWidth + distance, 0);
		            this.setTranslate(document.querySelector('.lg-next-slide'), this.___slide[this.index].clientWidth + distance, 0);
		        }
		    };

		    Plugin.prototype.touchEnd = function (distance) {
		        var _this = this;

		        // keep slide animation for any mode while dragg/swipe
		        if (_this.s.mode !== 'lg-slide') {
		            _lgUtils2.default.addClass(_this.outer, 'lg-slide');
		        }

		        for (var i = 0; i < this.___slide.length; i++) {
		            if (!_lgUtils2.default.hasClass(this.___slide[i], 'lg-current') && !_lgUtils2.default.hasClass(this.___slide[i], 'lg-prev-slide') && !_lgUtils2.default.hasClass(this.___slide[i], 'lg-next-slide')) {
		                this.___slide[i].style.opacity = '0';
		            }
		        }

		        // set transition duration
		        setTimeout(function () {
		            _lgUtils2.default.removeClass(_this.outer, 'lg-dragging');
		            if (distance < 0 && Math.abs(distance) > _this.s.swipeThreshold) {
		                _this.goToNextSlide(true);
		            } else if (distance > 0 && Math.abs(distance) > _this.s.swipeThreshold) {
		                _this.goToPrevSlide(true);
		            } else if (Math.abs(distance) < 5) {

		                // Trigger click if distance is less than 5 pix
		                _lgUtils2.default.trigger(_this.el, 'onSlideClick');
		            }

		            for (var i = 0; i < _this.___slide.length; i++) {
		                _this.___slide[i].removeAttribute('style');
		            }
		        });

		        // remove slide class once drag/swipe is completed if mode is not slide
		        setTimeout(function () {
		            if (!_lgUtils2.default.hasClass(_this.outer, 'lg-dragging') && _this.s.mode !== 'lg-slide') {
		                _lgUtils2.default.removeClass(_this.outer, 'lg-slide');
		            }
		        }, _this.s.speed + 100);
		    };

		    Plugin.prototype.enableSwipe = function () {
		        var _this = this;
		        var startCoords = 0;
		        var endCoords = 0;
		        var isMoved = false;

		        if (_this.s.enableSwipe && _this.isTouch && _this.doCss()) {

		            for (var i = 0; i < _this.___slide.length; i++) {
		                /*jshint loopfunc: true */
		                _lgUtils2.default.on(_this.___slide[i], 'touchstart.lg', function (e) {
		                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed') && !_this.lgBusy) {
		                        e.preventDefault();
		                        _this.manageSwipeClass();
		                        startCoords = e.targetTouches[0].pageX;
		                    }
		                });
		            }

		            for (var j = 0; j < _this.___slide.length; j++) {
		                /*jshint loopfunc: true */
		                _lgUtils2.default.on(_this.___slide[j], 'touchmove.lg', function (e) {
		                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed')) {
		                        e.preventDefault();
		                        endCoords = e.targetTouches[0].pageX;
		                        _this.touchMove(startCoords, endCoords);
		                        isMoved = true;
		                    }
		                });
		            }

		            for (var k = 0; k < _this.___slide.length; k++) {
		                /*jshint loopfunc: true */
		                _lgUtils2.default.on(_this.___slide[k], 'touchend.lg', function () {
		                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed')) {
		                        if (isMoved) {
		                            isMoved = false;
		                            _this.touchEnd(endCoords - startCoords);
		                        } else {
		                            _lgUtils2.default.trigger(_this.el, 'onSlideClick');
		                        }
		                    }
		                });
		            }
		        }
		    };

		    Plugin.prototype.enableDrag = function () {
		        var _this = this;
		        var startCoords = 0;
		        var endCoords = 0;
		        var isDraging = false;
		        var isMoved = false;
		        if (_this.s.enableDrag && !_this.isTouch && _this.doCss()) {
		            for (var i = 0; i < _this.___slide.length; i++) {
		                /*jshint loopfunc: true */
		                _lgUtils2.default.on(_this.___slide[i], 'mousedown.lg', function (e) {
		                    // execute only on .lg-object
		                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-zoomed')) {
		                        if (_lgUtils2.default.hasClass(e.target, 'lg-object') || _lgUtils2.default.hasClass(e.target, 'lg-video-play')) {
		                            e.preventDefault();

		                            if (!_this.lgBusy) {
		                                _this.manageSwipeClass();
		                                startCoords = e.pageX;
		                                isDraging = true;

		                                // ** Fix for webkit cursor issue https://code.google.com/p/chromium/issues/detail?id=26723
		                                _this.outer.scrollLeft += 1;
		                                _this.outer.scrollLeft -= 1;

		                                // *

		                                _lgUtils2.default.removeClass(_this.outer, 'lg-grab');
		                                _lgUtils2.default.addClass(_this.outer, 'lg-grabbing');

		                                _lgUtils2.default.trigger(_this.el, 'onDragstart');
		                            }
		                        }
		                    }
		                });
		            }

		            _lgUtils2.default.on(window, 'mousemove.lg', function (e) {
		                if (isDraging) {
		                    isMoved = true;
		                    endCoords = e.pageX;
		                    _this.touchMove(startCoords, endCoords);
		                    _lgUtils2.default.trigger(_this.el, 'onDragmove');
		                }
		            });

		            _lgUtils2.default.on(window, 'mouseup.lg', function (e) {
		                if (isMoved) {
		                    isMoved = false;
		                    _this.touchEnd(endCoords - startCoords);
		                    _lgUtils2.default.trigger(_this.el, 'onDragend');
		                } else if (_lgUtils2.default.hasClass(e.target, 'lg-object') || _lgUtils2.default.hasClass(e.target, 'lg-video-play')) {
		                    _lgUtils2.default.trigger(_this.el, 'onSlideClick');
		                }

		                // Prevent execution on click
		                if (isDraging) {
		                    isDraging = false;
		                    _lgUtils2.default.removeClass(_this.outer, 'lg-grabbing');
		                    _lgUtils2.default.addClass(_this.outer, 'lg-grab');
		                }
		            });
		        }
		    };

		    Plugin.prototype.manageSwipeClass = function () {
		        var touchNext = this.index + 1;
		        var touchPrev = this.index - 1;
		        var length = this.___slide.length;
		        if (this.s.loop) {
		            if (this.index === 0) {
		                touchPrev = length - 1;
		            } else if (this.index === length - 1) {
		                touchNext = 0;
		            }
		        }

		        for (var i = 0; i < this.___slide.length; i++) {
		            _lgUtils2.default.removeClass(this.___slide[i], 'lg-next-slide');
		            _lgUtils2.default.removeClass(this.___slide[i], 'lg-prev-slide');
		        }

		        if (touchPrev > -1) {
		            _lgUtils2.default.addClass(this.___slide[touchPrev], 'lg-prev-slide');
		        }

		        _lgUtils2.default.addClass(this.___slide[touchNext], 'lg-next-slide');
		    };

		    Plugin.prototype.mousewheel = function () {
		        var _this = this;
		        _lgUtils2.default.on(_this.outer, 'mousewheel.lg', function (e) {

		            if (!e.deltaY) {
		                return;
		            }

		            if (e.deltaY > 0) {
		                _this.goToPrevSlide();
		            } else {
		                _this.goToNextSlide();
		            }

		            e.preventDefault();
		        });
		    };

		    Plugin.prototype.closeGallery = function () {

		        var _this = this;
		        var mousedown = false;
		        _lgUtils2.default.on(this.outer.querySelector('.lg-close'), 'click.lg', function () {
		            _this.destroy();
		        });

		        if (_this.s.closable) {

		            // If you drag the slide and release outside gallery gets close on chrome
		            // for preventing this check mousedown and mouseup happened on .lg-item or lg-outer
		            _lgUtils2.default.on(_this.outer, 'mousedown.lg', function (e) {

		                if (_lgUtils2.default.hasClass(e.target, 'lg-outer') || _lgUtils2.default.hasClass(e.target, 'lg-item') || _lgUtils2.default.hasClass(e.target, 'lg-img-wrap')) {
		                    mousedown = true;
		                } else {
		                    mousedown = false;
		                }
		            });

		            _lgUtils2.default.on(_this.outer, 'mouseup.lg', function (e) {

		                if (_lgUtils2.default.hasClass(e.target, 'lg-outer') || _lgUtils2.default.hasClass(e.target, 'lg-item') || _lgUtils2.default.hasClass(e.target, 'lg-img-wrap') && mousedown) {
		                    if (!_lgUtils2.default.hasClass(_this.outer, 'lg-dragging')) {
		                        _this.destroy();
		                    }
		                }
		            });
		        }
		    };

		    Plugin.prototype.destroy = function (d) {

		        var _this = this;

		        if (!d) {
		            _lgUtils2.default.trigger(_this.el, 'onBeforeClose');
		        }

		        document.body.scrollTop = _this.prevScrollTop;
		        document.documentElement.scrollTop = _this.prevScrollTop;

		        /**
		         * if d is false or undefined destroy will only close the gallery
		         * plugins instance remains with the element
		         *
		         * if d is true destroy will completely remove the plugin
		         */

		        if (d) {
		            if (!_this.s.dynamic) {
		                // only when not using dynamic mode is $items a jquery collection

		                for (var i = 0; i < this.items.length; i++) {
		                    _lgUtils2.default.off(this.items[i], '.lg');
		                    _lgUtils2.default.off(this.items[i], '.lgcustom');
		                }
		            }

		            var lguid = _this.el.getAttribute('lg-uid');
		            delete window.lgData[lguid];
		            _this.el.removeAttribute('lg-uid');
		        }

		        // Unbind all events added by lightGallery
		        _lgUtils2.default.off(this.el, '.lgtm');

		        // Distroy all lightGallery modules
		        for (var key in window.lgModules) {
		            if (_this.modules[key]) {
		                _this.modules[key].destroy(d);
		            }
		        }

		        this.lGalleryOn = false;

		        clearTimeout(_this.hideBartimeout);
		        this.hideBartimeout = false;
		        _lgUtils2.default.off(window, '.lg');
		        _lgUtils2.default.removeClass(document.body, 'lg-on');
		        _lgUtils2.default.removeClass(document.body, 'lg-from-hash');

		        if (_this.outer) {
		            _lgUtils2.default.removeClass(_this.outer, 'lg-visible');
		        }

		        _lgUtils2.default.removeClass(document.querySelector('.lg-backdrop'), 'in');
		        setTimeout(function () {
		            try {
		                if (_this.outer) {
		                    _this.outer.parentNode.removeChild(_this.outer);
		                }

		                if (document.querySelector('.lg-backdrop')) {
		                    document.querySelector('.lg-backdrop').parentNode.removeChild(document.querySelector('.lg-backdrop'));
		                }

		                if (!d) {
		                    _lgUtils2.default.trigger(_this.el, 'onCloseAfter');
		                }
		                _this.el.focus();
		            } catch (err) {}
		        }, _this.s.backdropDuration + 50);
		    };

		    window.lightGallery = function (el, options) {
		        if (!el) {
		            return;
		        }

		        try {
		            if (!el.getAttribute('lg-uid')) {
		                var uid = 'lg' + window.lgData.uid++;
		                window.lgData[uid] = new Plugin(el, options);
		                el.setAttribute('lg-uid', uid);
		            } else {
		                window.lgData[el.getAttribute('lg-uid')].init();
		            }
		        } catch (err) {
		            console.error('lightGallery has not initiated properly', err);
		        }
		    };
		});
	} ());

	const elements = document.querySelectorAll(".image-gallery");
	Array.prototype.forEach.call(elements, function(el) {
	  imagesLoaded(el, function () {
	    el.style.display = "";

	    const isotopeGrid = new Isotope(el, {
	      itemSelector: '.masonry-item',
	      columnWidth: '.grid-sizer',
	      percentPosition: true
	    });

	    setTimeout(function () {
	      isotopeGrid.layout();
	    }, 500);

	    lightGallery(el, {
	      selector: '.masonry-item a',
	      download: false,
	      controls: true,
	      supportLegacyBrowser: false
	    });
	  });
	});

})();
